var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2AxSingleBedford(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1748.62 721.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbb040;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-125,.cls-126,.cls-127,.cls-128,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-136,.cls-137,.cls-138,.cls-139,.cls-140,.cls-141,.cls-142,.cls-143,.cls-144,.cls-145,.cls-146{stroke-width:0px;}.cls-2,.cls-6,.cls-7,.cls-29,.cls-147,.cls-130,.cls-131,.cls-133,.cls-143,.cls-144,.cls-145{mix-blend-mode:multiply;}.cls-2,.cls-123{fill:#f1f2f2;}.cls-3{fill:url(#New_Gradient_Swatch_4);}.cls-4{fill:url(#New_Gradient_Swatch_5);}.cls-5{fill:url(#New_Gradient_Swatch_3);}.cls-6{fill:url(#linear-gradient-92);}.cls-7{fill:url(#linear-gradient-91);}.cls-8{fill:url(#New_Gradient_Swatch_5-2);}.cls-9{fill:url(#New_Gradient_Swatch_3-3);}.cls-10{fill:url(#New_Gradient_Swatch_3-4);}.cls-11{fill:url(#New_Gradient_Swatch_3-9);}.cls-12{fill:url(#New_Gradient_Swatch_3-8);}.cls-13{fill:url(#New_Gradient_Swatch_3-7);}.cls-14{fill:url(#New_Gradient_Swatch_3-6);}.cls-15{fill:url(#New_Gradient_Swatch_3-2);}.cls-16{fill:url(#New_Gradient_Swatch_3-5);}.cls-17{fill:url(#New_Gradient_Swatch_4-2);}.cls-18{fill:url(#linear-gradient-100);}.cls-19{fill:url(#linear-gradient-109);}.cls-20{fill:url(#linear-gradient-108);}.cls-21{fill:url(#linear-gradient-106);}.cls-22{fill:url(#linear-gradient-107);}.cls-23{fill:url(#linear-gradient-102);}.cls-24{fill:url(#linear-gradient-104);}.cls-25{fill:url(#linear-gradient-103);}.cls-26{fill:url(#linear-gradient-105);}.cls-27{fill:url(#linear-gradient-111);}.cls-28{fill:url(#linear-gradient-110);}.cls-148{mask:url(#mask);}.cls-29{fill:#fff;}.cls-30{fill:url(#linear-gradient);}.cls-149{filter:url(#luminosity-noclip);}.cls-31{fill:#ef4136;}.cls-32,.cls-130{fill:#6d6e71;}.cls-33{fill:#f15a29;}.cls-34{fill:url(#linear-gradient-38);}.cls-35{fill:url(#linear-gradient-33);}.cls-36{fill:url(#linear-gradient-29);}.cls-37{fill:url(#linear-gradient-32);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-36);}.cls-41{fill:url(#linear-gradient-39);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-37);}.cls-44{fill:url(#linear-gradient-35);}.cls-45{fill:url(#linear-gradient-28);}.cls-46{fill:url(#linear-gradient-25);}.cls-47{fill:url(#linear-gradient-11);}.cls-48{fill:url(#linear-gradient-12);}.cls-49{fill:url(#linear-gradient-13);}.cls-50{fill:url(#linear-gradient-10);}.cls-51{fill:url(#linear-gradient-17);}.cls-52{fill:url(#linear-gradient-16);}.cls-53{fill:url(#linear-gradient-19);}.cls-54{fill:url(#linear-gradient-15);}.cls-55{fill:url(#linear-gradient-23);}.cls-56{fill:url(#linear-gradient-21);}.cls-57{fill:url(#linear-gradient-18);}.cls-58{fill:url(#linear-gradient-14);}.cls-59{fill:url(#linear-gradient-22);}.cls-60{fill:url(#linear-gradient-20);}.cls-61{fill:url(#linear-gradient-27);}.cls-62{fill:url(#linear-gradient-24);}.cls-63{fill:url(#linear-gradient-26);}.cls-64{fill:url(#linear-gradient-45);}.cls-65{fill:url(#linear-gradient-46);}.cls-66{fill:url(#linear-gradient-44);}.cls-67{fill:url(#linear-gradient-48);}.cls-68{fill:url(#linear-gradient-49);}.cls-69{fill:url(#linear-gradient-47);}.cls-70{fill:url(#linear-gradient-42);}.cls-71{fill:url(#linear-gradient-43);}.cls-72{fill:url(#linear-gradient-40);}.cls-73{fill:url(#linear-gradient-41);}.cls-74{fill:url(#linear-gradient-59);}.cls-75{fill:url(#linear-gradient-57);}.cls-76{fill:url(#linear-gradient-58);}.cls-77{fill:url(#linear-gradient-55);}.cls-78{fill:url(#linear-gradient-56);}.cls-79{fill:url(#linear-gradient-53);}.cls-80{fill:url(#linear-gradient-51);}.cls-81{fill:url(#linear-gradient-52);}.cls-82{fill:url(#linear-gradient-50);}.cls-83{fill:url(#linear-gradient-54);}.cls-84{fill:url(#linear-gradient-60);}.cls-85{fill:url(#linear-gradient-61);}.cls-86{fill:url(#linear-gradient-62);}.cls-87{fill:url(#linear-gradient-65);}.cls-88{fill:url(#linear-gradient-79);}.cls-89{fill:url(#linear-gradient-78);}.cls-90{fill:url(#linear-gradient-77);}.cls-91{fill:url(#linear-gradient-75);}.cls-92{fill:url(#linear-gradient-76);}.cls-93{fill:url(#linear-gradient-74);}.cls-94{fill:url(#linear-gradient-67);}.cls-95{fill:url(#linear-gradient-68);}.cls-96{fill:url(#linear-gradient-66);}.cls-97{fill:url(#linear-gradient-63);}.cls-98{fill:url(#linear-gradient-69);}.cls-99{fill:url(#linear-gradient-64);}.cls-100{fill:url(#linear-gradient-71);}.cls-101{fill:url(#linear-gradient-72);}.cls-102{fill:url(#linear-gradient-70);}.cls-103{fill:url(#linear-gradient-73);}.cls-104{fill:url(#linear-gradient-84);}.cls-105{fill:url(#linear-gradient-85);}.cls-106{fill:url(#linear-gradient-82);}.cls-107{fill:url(#linear-gradient-83);}.cls-108{fill:url(#linear-gradient-89);}.cls-109{fill:url(#linear-gradient-88);}.cls-110{fill:url(#linear-gradient-86);}.cls-111{fill:url(#linear-gradient-87);}.cls-112{fill:url(#linear-gradient-80);}.cls-113{fill:url(#linear-gradient-81);}.cls-114{fill:url(#linear-gradient-98);}.cls-115{fill:url(#linear-gradient-93);}.cls-116{fill:url(#linear-gradient-90);}.cls-117{fill:url(#linear-gradient-96);}.cls-118{fill:url(#linear-gradient-97);}.cls-119{fill:url(#linear-gradient-94);}.cls-120{fill:url(#linear-gradient-95);}.cls-121{fill:url(#linear-gradient-99);}.cls-122{fill:#3c2415;}.cls-124{fill:#58595b;}.cls-125{fill:#808285;}.cls-126{fill:url(#New_Gradient_Swatch_3-10);}.cls-127,.cls-134{fill:#000;}.cls-128,.cls-133{fill:#a7a9ac;}.cls-129{fill:url(#New_Gradient_Swatch_11_cop);}.cls-131{fill:#ed1c24;}.cls-132{fill:#be1e2d;}.cls-134{opacity:.5;}.cls-135{fill:url(#linear-gradient-4);}.cls-136{fill:url(#linear-gradient-2);}.cls-137{fill:url(#linear-gradient-3);}.cls-138{fill:url(#linear-gradient-8);}.cls-139{fill:url(#linear-gradient-9);}.cls-140{fill:url(#linear-gradient-7);}.cls-141{fill:url(#linear-gradient-5);}.cls-142{fill:url(#linear-gradient-6);}.cls-143{fill:url(#linear-gradient-101);}.cls-150{isolation:isolate;}.cls-144{fill:#414042;}.cls-145{fill:#939598;}.cls-146{fill:#231f20;}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 634.65,
    width: 1548.62,
    height: 87.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 634.65,
    width: 1548.62,
    height: 87.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("image", {
    width: 1549,
    height: 88,
    transform: "translate(-.2 634.6)",
    xlinkHref: "data:image/png;base64,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"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5",
    x1: 868.57,
    y1: 494.03,
    x2: 868.57,
    y2: 526.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#603913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4424.59,
    y1: 6649.99,
    x2: 4424.59,
    y2: 6471.31,
    gradientTransform: "translate(-5165.61 4952.52) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#262224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#525254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#403f41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#252122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4446.08,
    y1: 6468.33,
    x2: 4446.08,
    y2: 6652.79,
    gradientTransform: "translate(5932.63 7158.61) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3b393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3a393b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 6468.33,
    y2: 6652.79,
    gradientTransform: "translate(5930.06 7156.03) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5926.88 7152.85) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5923.05 7149.03) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 6468.32,
    y2: 6652.8,
    gradientTransform: "translate(5918.55 7144.53) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5913.51 7139.49) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5907.92 7133.9) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5901.87 7127.85) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 6468.32,
    y2: 6652.8,
    gradientTransform: "translate(5895.2 7121.18) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5888.27 7114.25) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    y1: 6468.33,
    y2: 6652.79,
    gradientTransform: "translate(5880.84 7106.82) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 6468.32,
    y2: 6652.8,
    gradientTransform: "translate(5873.19 7099.17) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5865.17 7091.15) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5857.06 7083.03) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(5848.83 7074.81) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3142.8 -5962.44)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3140.23 -5965.02)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 6468.32,
    y2: 6652.8,
    gradientTransform: "translate(-3137.05 -5968.2)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3133.22 -5972.03)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3128.72 -5976.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    y1: 6468.32,
    y2: 6652.8,
    gradientTransform: "translate(-3123.68 -5981.57)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3118.1 -5987.15)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    y1: 6468.32,
    y2: 6652.8,
    gradientTransform: "translate(-3112.05 -5993.2)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3105.38 -5999.87)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3098.45 -6006.8)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3091.01 -6014.23)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    y1: 6468.33,
    y2: 6652.79,
    gradientTransform: "translate(-3083.36 -6021.89)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3075.34 -6029.9)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3067.23 -6038.02)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3059 -6046.24)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    y1: 6468.32,
    y2: 6652.79,
    gradientTransform: "translate(-3051.16 -6054.08)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 4403.11,
    x2: 4403.11,
    gradientTransform: "translate(5889.67 7201.58) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 4403.11,
    y1: 6468.33,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5887.09 7199) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5883.91 7195.82) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5880.08 7191.99) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.8,
    gradientTransform: "translate(5875.58 7187.5) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5870.54 7182.45) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5864.96 7176.87) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5858.91 7170.82) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.8,
    gradientTransform: "translate(5852.24 7164.15) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5845.31 7157.22) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 4403.11,
    y1: 6468.33,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5837.87 7149.79) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.8,
    gradientTransform: "translate(5830.22 7142.13) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5822.21 7134.12) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5814.09 7126) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(5805.86 7117.78) rotate(-180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3099.84 -5919.47)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3097.26 -5922.05)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.8,
    gradientTransform: "translate(-3094.08 -5925.23)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3090.25 -5929.06)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3085.75 -5933.56)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.8,
    gradientTransform: "translate(-3080.71 -5938.6)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3075.13 -5944.18)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.8,
    gradientTransform: "translate(-3069.08 -5950.23)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3062.41 -5956.9)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3055.48 -5963.83)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3048.04 -5971.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 4403.11,
    y1: 6468.33,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3040.39 -5978.92)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3032.38 -5986.93)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3024.26 -5995.05)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3016.04 -6003.27)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 4403.11,
    y1: 6468.32,
    x2: 4403.11,
    y2: 6652.79,
    gradientTransform: "translate(-3008.19 -6011.12)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 4424.59,
    y1: 6469.82,
    x2: 4424.59,
    y2: 6653.29,
    gradientTransform: "translate(-3029.68 -6032.6)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1510.63,
    y1: 488.7,
    x2: 1510.63,
    y2: 520.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#939598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#909295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#77797b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#656769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5b5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 782.22,
    y1: 494.83,
    x2: 782.22,
    y2: 474.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    y1: 476.36,
    y2: 418.35,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4",
    x1: 262.38,
    y1: 635.63,
    x2: 262.38,
    y2: 448.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3",
    x1: 262.38,
    y1: 465.75,
    x2: 262.38,
    y2: 624.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 262.38,
    y1: 600.42,
    x2: 262.38,
    y2: 485.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 262.38,
    y1: 490.9,
    x2: 262.38,
    y2: 595.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 262.38,
    y1: 491.92,
    x2: 262.38,
    y2: 592.82,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 262.38,
    y1: 572.05,
    x2: 262.38,
    y2: 512.37,
    gradientTransform: "translate(705.54 134.15) rotate(73.15)",
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 262.38,
    y1: 526.06,
    x2: 262.38,
    y2: 560.53,
    gradientTransform: "translate(460.43 -26.64) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6e71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 262.38,
    y1: 553.24,
    x2: 262.38,
    y2: 532.05,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 396.27,
    y1: 224.42,
    x2: 379.88,
    y2: 224.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#808285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-2",
    x1: 484.56,
    y1: 412.99,
    x2: 484.56,
    y2: 512.99,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-3",
    x1: 1304.86,
    y1: 413,
    x2: 1304.86,
    y2: 510.36,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-4",
    x1: 1459.33,
    y1: 413,
    x2: 1459.33,
    y2: 510.36,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-5",
    x1: 817.48,
    y1: 413,
    x2: 817.48,
    y2: 510.36,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-6",
    x1: 971.94,
    y1: 413,
    x2: 971.94,
    y2: 510.36,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_4-2",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#New_Gradient_Swatch_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-7",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#linear-gradient-68"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1155.62,
    x2: 1155.62,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1155.62,
    y1: 491.73,
    x2: 1155.62,
    y2: 592.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1155.62,
    y1: 560.89,
    x2: 1155.62,
    y2: 523.64,
    gradientTransform: "translate(1505.97 -685.12) rotate(80.78)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1155.62,
    y1: 556,
    x2: 1155.62,
    y2: 529.38,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 415.35,
    y1: 487.25,
    x2: 415.35,
    y2: 405.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c2415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -1241.86,
    y1: 7185.94,
    x2: -1241.86,
    y2: 7104.37,
    gradientTransform: "translate(-810.21 7617.15) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#020000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0c0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#1b0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4e0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: -1382.05,
    y1: 7238.9,
    x2: -1382.05,
    y2: 7306.74,
    gradientTransform: "translate(-950.41 7729.69) rotate(-180)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: -1382.05,
    y1: 7298.95,
    x2: -1382.05,
    y2: 7245.88,
    gradientTransform: "translate(-6941.44 -201.34) rotate(-95.65)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: -1382.05,
    y1: 7251.63,
    x2: -1382.05,
    y2: 7293.61,
    gradientTransform: "translate(-950.41 7729.69) rotate(-180)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: -1382.05,
    y1: 7288.79,
    x2: -1382.05,
    y2: 7255.94,
    gradientTransform: "translate(-950.41 7729.69) rotate(-180)",
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 608.54,
    y1: 434.62,
    x2: 608.54,
    y2: 546.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#454446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#444345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#353334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2a2728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#242021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 533.09,
    y1: 532.93,
    x2: 533.09,
    y2: 553.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#383739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#212122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 608.54,
    x2: 608.54,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 683.98,
    x2: 683.98,
    xlinkHref: "#linear-gradient-87"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 541.62,
    y1: 440.6,
    x2: 566.02,
    y2: 440.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#28292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58595c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_5-2",
    x1: 553.82,
    y1: 440.86,
    x2: 553.82,
    y2: 423.84,
    xlinkHref: "#New_Gradient_Swatch_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 157.57,
    y1: 291.67,
    x2: 157.57,
    y2: 179.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 304.78,
    y1: 291.67,
    x2: 304.78,
    y2: 179.83,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 198.5,
    y1: 135.79,
    x2: 198.5,
    y2: 442.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#e2e3e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#c8cacc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 32.38,
    y1: 442.65,
    x2: 32.38,
    y2: 550.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#414042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 110.22,
    y1: 482.33,
    x2: 110.22,
    y2: 447.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58595b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#747577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8e8f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a2a4a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#b1b2b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#b9bbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#bcbec0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#b8babc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#adaeb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9a9b9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#807f81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#5e5c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#353233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_11_cop",
    x1: 96.73,
    y1: 541.69,
    x2: 96.73,
    y2: 549.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#e3c8af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-8",
    x1: 1499.08,
    y1: 437.09,
    x2: 1499.08,
    y2: 483.96,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-9",
    x1: 1509.94,
    y1: 522.42,
    x2: 1509.94,
    y2: 539.42,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_3-10",
    x1: 1498.46,
    y1: 415.98,
    x2: 1498.46,
    y2: 556.35,
    xlinkHref: "#New_Gradient_Swatch_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 786.96,
    y1: 5075.82,
    x2: 786.96,
    y2: 5094.26,
    gradientTransform: "translate(2306.99 5557.02) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbb040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15a29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 1520.03,
    y1: 439.63,
    x2: 1520.03,
    y2: 459.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be1e2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e0001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 1037.15,
    y1: 416.9,
    x2: 1037.15,
    y2: 502.92,
    gradientTransform: "translate(-88.31 579.47) rotate(-30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d6e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#969799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#bdbebf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d9dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#eaebec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 1274.09,
    x2: 1274.09,
    gradientTransform: "translate(2150.22 1485.2) rotate(-150)",
    xlinkHref: "#linear-gradient-98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 984.25,
    y1: 10.79,
    x2: 984.25,
    y2: 510.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#dfe0e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 228.59,
    y1: 354.03,
    x2: 228.59,
    y2: 337.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 209.05,
    y1: 342.44,
    x2: 209.05,
    y2: 349.57,
    xlinkHref: "#linear-gradient-94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 246.63,
    y1: 342.44,
    x2: 246.63,
    y2: 349.57,
    xlinkHref: "#linear-gradient-94"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 227.84,
    y1: 343.39,
    x2: 227.84,
    y2: 348.53,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 84.75,
    y1: 422.49,
    x2: 84.75,
    y2: 433.67,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -1766.4,
    y1: 443,
    x2: -1766.4,
    y2: 423.49,
    gradientTransform: "translate(3149.8 866.04) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1c24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -1791.43,
    y1: 423.32,
    x2: -1791.43,
    y2: 443.86,
    gradientTransform: "translate(3199.86 866.04) scale(1 -1)",
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -1187.96,
    x2: -1187.96,
    gradientTransform: "translate(1992.92 866.04) scale(1 -1)",
    xlinkHref: "#linear-gradient-106"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: -1212.99,
    y1: 423.32,
    x2: -1212.99,
    y2: 443.86,
    gradientTransform: "translate(2042.98 866.04) scale(1 -1)",
    xlinkHref: "#linear-gradient-96"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 7.62,
    y1: 278.9,
    x2: 18.41,
    y2: 310.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8b8f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9296a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9ea1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#afb2bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dfe1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c5c7ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#9a9daa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8a8e9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f867e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#938167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 12.87,
    y1: 183.21,
    x2: 12.87,
    y2: 274.47,
    xlinkHref: "#linear-gradient-110"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-147",
    width: 1549,
    height: 88,
    transform: "translate(-.2 634.6)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABg0AAABXCAYAAAA3SwWuAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4nO2dW5ekKpCFN6BZ1d1rzsvM//+Z53RlKswDFwE1r15A97dWlaYXBDSVjG1EiNvtZvquR9d36Pve/nU9bl2Hrruh6zoIIdw6jb7v0HXDn4BAr3tcr9domx667yGlRK97/PxcofsevdZhKoXAz88Pej1s3/c9lFL4+/cHWmtoo+1Uaxit0TTNsC776/se2tjttDYwxk4vlxZ///6F1satN7Y8o9Fr+9mY+E/jcvnC379/k2Xabffnz59ROTrMm6G+xkAqCd1rfH9/j8rxf23bJsdSSkFru085mCeWPFpREk+2p4q2AKdsTzVtAfLK1n1ugIftqaotwN32LNSWr6+vZQoKmIm5/MPS7HHMmePuccwNj3v8/h0OcvxjZsfd45hPHPf379+r1uY1pitb97PzhOO02YWlcrSxJ3Cq8drkghqocQx6TP7+/TuzZq8x4VrMXHMLtKessQSplX///RcAIIRIliefBfDn928AAv/++29YJ4Sw8wIQEPjz5w/+++9fAHb579+/IQRwu3UAzGhsLoRw90yTfDe+v79Dmf74AgJSCly+vkbLv7+/XV0AuDoJCCilAABfX5dQVyHs8vZygRQCQsowbZSCEPYY8TrVKFzaC6SUkFLa5VJCKRmWfX99u+W2fCkl2raFUmryz69rmiZa3kBKIZrQONcQjy/cCwa+0bZzpGuwgHbrmqa1HSENeqWgdQ/daxjXKdfrFa1orYHfGdalUrjdbrjdblDfX9C9XdfrwfivjRULdFiW/im37u9/f61R3pggBDRt44z7JhEhLu0F2vh9UiP+5XKBMToVDFyZ7aXF99dXOLaQMhIPUhEhnn5//0rWNU2Dn59B/Pjnn38yQUHj+9ev4erd8Mf0U0s3/tH71KFZp8eH3nRwU1qdSqvP9MH8kq/L5Ymtn125JvMHLrO+8wdnfZfkxTqzvm9Q4rPoHiWOMR5R4nPjHu/X9/ef33fXL0+J37kS6zR9oP2vQ9bpeR4YumcXrkn5dZpcwjpNHvSZOiX3eDIJ+4iQcrAagLVN//7z282lokG8LBYN/vz5g3//+zfYtv/3f/8vGPN9uUL+BYyTBty0UQrGAJfLBYCBCcsbXC4tgFRkaxprSr9cLsl9t2kaXL4uWY0F2raxAgKAtm3DmrZtB7HC2IKatk1FAqUg/HK3TCoZBJLGiQIyiAYKBgYSgBB2OymlrWf2jIjFCyGEbXdkCweABrALhRAQUkAaCaOssd7uZIIiEkSFPjpbAKRSgLkCjULfa0hjYFwDLpcLrtcfXNoLeq0hYCCNgHEdppSCFMKuEwbSdZjue9smZ3gXwu7z6/dvXK9XKKkGzwJjDfHdzXpHNG0b9gvruhtutw5t2wRjvtE66ZS2be08jBMBvOfBxQoHxuDXr98wxuDn+oOu65wXQWrwz+d//foFwOB6u1lhpO/xzz//MxIsdDT/+9evhQZxaw2i1xpIjQdCjbv+3iqymB/zwKuVWaD7duRMbQVWb29RbQVeqdCZ2vry1sW1FVjt3BbZVuDZip2prS9tWWxbgcXPbdFtBZ6p4NwWf37/XtBwuJZB8mDlvn09sdx1y0133qLcP3w7lxBCCAn8+f1n+JAJBFPL/vz5jX//+y/Yq/8vEgpGgoFAYqtt28bb6gEYZ0vWaNo2PKwvX5dgX7YGfxHq4G3PsShwuUTbXy7u+O4lfCEgpULTNkEY8KKHCsZ/FTwGpJT4ulwgpIAQ3gtB4HJxngZCBo+CsI+wXgVSDJ4I3pvAOwDYaRP2GTCJBwMAiK7rjA9L5MP8dF3n3vq34YZsSKE+LAtv+vfea8Au67oefW/DGWk9hO3RfY+u79F3Hbq+swZ/rV14ovgYPgTR38GrwL/Bn4QdmghPpPXICD/682JBZKC//lzDheLFAhirLP39+18iGBht0DTKXVSD+uS3T5fZixEwkEqh7zonrgzbDdNU5YqVq5RPBrGF7fvUoHvYaLo/Hu1VAEVVpkbK6MAyaoGCKlIzZXRiEbUoohJHYd/OLOJUFlGJI7FdhzZN+3gjQgghhBBCVqbrOmv/G6L+IJ+LF+m+h1JNKibcme+7DtfrDZdLOxpte4N7XH7btui7Hm3buLf7RSQECDSNCm/0W+N+asCPDfo+3JBwAoMv7/vrKwgDQojBw0AIKzwE8UOgaRq3bBAiBgHAHqtpGkjpxIHIC8GHH7LLFaRSUEoGEcKHJopECxueyDfKGBMK6tBZ47rQaC8tlLaG/uv1GoUycidAADCAUnCCQe+8FHoAxjVCQooWqlHQ2i77/vXL5Ua4QcrvSIzoXUggHaaqaWC0xt+fcU6D1gkNOhIGBkP/UIaWBkZL60XhBI2vr69g3AdgBQAICGGcFwEgYWCEAYT3RgCceT8x9OdiQNu2MDC4Xa/W3cVfeBPWc4PITcUAt9vt/jeJEEIIIeQBycA3MG+QfuFdgCep4FgLu7vVdqzpa+RTylCRyqgFCqrIWuzfwP1r4CimImuyfyN3r8HuFdiSk78YsXsFtubE57vycy3l2Khe55g0zjeQ5h4wsJFkjA9lrx6/XNw0DQwM+q6HkAI/2uDXLxtuP8k94PIU5CF7vr6/reggRCpECIGvy9dI3LA5EMRoH9XYCCoXP+4WwkZV8cJAVN9YQFDKvvHfNm3wKhCuN6xYoBJhQAonAggZylFKom3aKISRTMQBrwnEuSP8UZIeDokjAOui0ABCWq8Bv65tW3RdZxUIraG9mIAbhO6htYDuBXrhwvpojevP1XokiB7QAIxGH4UnEgC0saGJICW+v79x6zooKZOQPcYYqKZB5/IgeNeROPlwLBy0bQttDH6coBA8FozBpW3x398sp4ELK3T5uoR94uW+zLtigTuZuedALA6kM7CuLDPrCCGEkCPzvMHyvYfjwuPh1QtifdcvbEEt4g3Kq+86okHMiQ0QRVTgWXie6mG/ytKg9wonPE/VnSPPPhU/03lSUcjpx3A8uuxOyxW2zZj0wQvacEKAC0U/daD8Pe2madAoKx5Mv9BtX2y/XL7CQl+Hr8s4obxqFOBy4ob6unrZPAfRy+FNk4gITds62/IleBsoKW27lAq5DKQaBIAgYjhR48t5KwzCgPVAEEIGjwifZNmLAUIOtv5YLAg5D0aeHLYNwdNg2NASKww+3r/W2hrrXfJhv04IiUvbouut94EJSYcNpNDQrYbsNbSW6LWG+pLQvcbP9WoN/lIOyYW1hhbARbRRqCADrXvAJWFuLxfX0YPB3+Yt6Kwri18XhywKHgcm5DUYcg8MeQwuzpMgFxJskuTW7hNfuLYTwgU1xMQaLupHogFgwg+2ap+zhBBCyJs0zfM/JBZ/Tq724F2u4DO2efHSVh1gFXqud/U0yDmRQeZEVqDNj7j7D6VtK3C+/gUO3cfs32IPdsxx6PKFn3FctnxpaxS4TuF7tDuIBplNVTmDvw8N7+dtiM2xrdV/p030LxcSQnmwxnrtRIDYxoywLDpmlsjY50DwFvSLe3ndaB08CEJYI+c5IERrQwk5o3/bRsJA9KeUgmqaEIZIQKBpGysQuLA/TaOS/AapWDCELPI5DXLRYJimx3aJIND4ZMfxdIjNZMUBH7rId8qQ76AP21yvVzTCvfkvAN3p4OZxaS/opM2e7AUFISRa7XMi2LwISn2FEERGp7kHjLZ16CNvAaM1NGBPtKuvcifWGAMjJWAM/jQNrj8/QY0ayh3CGH1FF8fUX3uxQkTf9cMF90AsyPMWxBdz8gMtEhUmPhJCyCztZcbYU4lRsKyjrX1A9l3hB9jhSFsdjH1X+EG2PVJ2oNFzpK5fx9seZZWDrF/zem/P7JsdCn669MmccxxHFXzQg/dfvQ+BnY+05QEP2n97DeAOcaT0YO2lHey5sWHf2Df2gx3WGU29aOBtqNYDYFxw3B5v3/YRauIyWmffjiPMXL4u4SX3S5YIWUiJ5usrEQbsG/+DSBCvk87TwOcogBMR/D7BFu/yGficCYB95nqRQQrnmdCMchCgbduR8JDkWcg8DPLp4Exge01orc2codwnRg5eAEKgu3XOiyBNPHz1XgNRguSm8QmPr0Es6Ps+eYv/ertCSpUKAUbjer0lyZCllDBa43q7wWe6Nka7WFa2ruHiChdSOt91HQwweDAAIdQS/HbR9O/fv4nSZIyxuQZysWBi33h6vd5Cp8diwfhaHkQF5jQghDzLK4nC3+JAP2Ceobga1WvReIuyaoPD/Yh6RDk1wSF/hD1ij5o85WnwVsWO+KbfEdv00Y7rl8Y2Lbnz4iVxDLos5dUIpxsHAaXVBhwPlcAxVYiHbF2Tth0izkgXssf/S+2s9l/TxhFq7FaPnktt0+J6u9ooM36hK09ImS6HDa2ltQ7GdwH37IvzFrgQQ3GegnidACCd3TkOV6SaxpbnPRUE0DRtSIbsDfmqUYMHgQ9ZlHkGeOHBt19FwoMPZxT/SSmdcIFEWMjSFoi7osFYRDDo+26UiDjkE9A6JKTwooA2GrfrLfEoSPaLt4/CAWljcP35CYmTEzEhEgusdwRwu3WRUGBCiKFYPLj72V1g1pugCxdkdP0MF2r8ObtokwvZzV9vN/uDbNgQ6RxG664UDciBaF/4QVHOI/JFKn2TbC2qrPXJfpg+or4a43QCyyPqqq2D53DE2jV+OjzR3Yq8V8v1bKfl1ke+FNd5JcpRK3an3pqDY88Jqq05x6Aj6qw1OI6Zocpan1Awe4Y1a9w64/nYxhrNA8FWOxjbsyTFbhkASCESe6/PqxsQYU9rmPdv/SMNKzT32Rv+cyEgFg7CMSOjftN4EUKEdABN22SGfYXLpQ1JkaWwCZVb5/EgBIJYEOc3iL0PlFJBFACQCAOJ4BAleAZCGgMrGtg+dwbyaOqFgEQUiAQEY4blt1sXGfMzjwID9H2Hvu8hhAhlWu8EE3kU6CBMwBn980TIt9stCAjBQ0Fr3LouEwHGAoL/G2+Trp/cxgBKSdy6LhEMYkZfnkhh6PreKk5PYEBPg615xai9JfU9Ql5ksQYeu6eO3TqU9Ppe8Ry6das07pg9dsxWOWgEe4klWrVWToN8nJy9eTO/38OCSy3n/tbxmhLHncf8hmRw3PkSh28lxbOXOXQLOQ59i0O3kGPSt/ikdW3borvdbN6AGaEgFhGUUuj73oapj8hT+g45e124n8jwPzcfBIKZ+caJA4OQYEMOxXUJIkIcjkiOwxHFoYFEFEZIKRduyO3bNg2EFFCqCe2PQw4pqZwXBJLQRHHIIt8feW7jeJ2bgRRCCGNx52B+6uc7Z5z3XgG97kPon1hc8KKCEBK32xV9r4PIEIcm8tt6IaFxrh/X63XIO6BtIuRYgBAQ1kPBeRx0XeRpkIkFSqknRIGJvwnBobvdRt4Gw//sQp78nF/4w8UeCzWEEEII2YdjD+UJSYl/WBmMf2gRQgghhKwBx9wkJoxBo7f/wxox/nxvnybKgQAM5lvVqLuiwJSI0Ex6H1ghYCwaKHdIE97gj7cZQgEpG4JI2jzAcQJi4QQCK04MOQ28x8HXJd8+8jjIkhz7PAeeXCRQEy+3ey8DAEhEA0/8OZ9PPQjSv+v1OhnSqLvdkhBEIZQQbHl9b5Mmey8FrQ1u12vIneBFBe9hMHg9IJQDYAhZ5PMjRKKC8skuJoWBsTgwJy7cus53xnDhLfTZJ3EGrDhDCCGEELIk+Zs4CU++ef0K6zgSlV6/5Ureon53r4k9earxNDesAXt1BV7uVJ6FpWGPLsxbHcqzsCTszQX5uDPfLyDE7l+KFcajy5aUFzY/Jr37IouYX+vXDEl9hyOFnAMPPA1iIQDZ2/rhLf3sszfE+xy/fl8hACkVhLA5FWKDv1IKbduEbXMvBCmtwOCTIyulQhgj7zkRbx/X0x9zKunxfLcGjwMBAJO/EuIChBBBOPDL/Wfd68jobpP8esN/11lvAKEMpLxEHggaSjXOg0Dj5+cnHMMIA2EEpDQwpklyH0h5cYmQbUgjKYZwRvBv5gtACsAIBWEMYCSMHMQBGAEYAzHhSZB6KWAsGsTb4nVxALAKzr3tJucJIYQQ8hJz4QB3e7ZGnom7HHq3g7LNmx76TZ4Nn7nGsU/NqPPYm+/AXvsAXoOLwF57k9mOY4++Qy29lhtxV+WM49HkwPW1+6kx6R2Dtyd9e94klcrDBU0JBPGysbeACIb4eLkrIBxfSunyDEhIISCVTI8vBBplQwm17cVG3skEgKZp0DStEw6GHAUAQgj9IAYICamG9T7RsWrU7PfunnjgaaY2zD0PYrHAH8wYE4z9fd8nyRv6vgcgoHUPKSWu16svyTUG0LCN/vr6RpwL4Xa7wRjg6yJxu90gWhk8DLSWaLSGliZaNuRWGDwPhqnu+2lxYHLZvIAQLwtnCC+IB+5C9V+CObEg3YcQQgi5z5RLYQmU/ywzxVey8OolL0aUSvE13FFQ8pR6D9mK4q+RXTDJhAywS2ao4HmwB0fvFbWlAfgF6uj38sehQBVVrOb+U3wtSxqTivDvvf1nsKF+IlHgzrRx4YFEJCiMhANn10Y0L5VMPAxCLgOlnAhh69BE4oEUAtJ99p4CPrExYL0UmqaBkhLa6JHXw5DoePA2sE0Rib3/HdGu8XkN4oVzakO83BvQ+75P4vH77ZSy3gJGG5jWBFEgyQ/QdZDSQGsBIw2EtiqJ1gZdd0OD1goCQloPBGFgmiYICEJrXC4yJGJGJAb4eenCEsXrYiEhFxEefTbRzT2Y+KPPTfAmMOlzIBEExutGngmV3PgIIWRL9g2jMXFfrvxWXXn1Hebuxxo5QBOQtOIADTpAExxjY3BZ4Ylmevo4J2CWEzQRR3yOPsMJmogjPouf4STNxL1n+ifC8zH675j3tQM0wXG8e9MBmhCRjkufHZMqZ6ifExbm5IZGufK9QACf42Bs5E/n7fZWIBjEBS8ExB4KakKYaFz4IdUo+zJ5FI5ICIH24kUAGfIceIP/19dX8GoArJihVBMcLrxgEIsHcVJjbxN/xqsg9F+08Vu/EmJxoGmaRAjwFeq6zlZKwooFThQwkXdA27TQxnomaG0ghIYxAkLY9b6s262DEMaGH1IKfd+h73tIIUMy5KEOiASC6c9KysTToO+7bDs/P142GPhz8QDB0J94E7woFvj/x7oREELe4ZOQEY84/j3myRYevCMO3jzHg1aeoBNO0ETwPK/XxKWeNXWegmNeV3VW+06t62xQrdVe7O1xG32gDJY6F88ZyDkG9ZygiXiqlefoiLM0E0cdO7zKGs2Mx6Tz5VujqlIP8h9MiAqxKBGvkUqNvQ0EoKQKXgSxkKDivAjZeh9yyBPnMBDS7QthcxRI61EADMb/OKeBX+fFBNX4bVSwv0sprVcEknwEkUjwmmCQ85ZokHscpMus0b9t20RMGHIaiOBdoIWGMLYxfp3RBkIYSCnQdZ39fJEhBNHt1rlkDlZQkEbACIMv+W23T7wKshBEU8uMgVJytKzru8HAHwkFBtFgYVYQeM3LYHLdSW40hHhUs4DR4qTfm5M22/Fh60/ceSduuuODHjhx55246RFv9ELBHffw+VtI3QuphqMeI1Eh1XDUY2gpqCrYQ1B5xjj+6NDy8KHPOAb9FHYBx6Kfwm4AjjQu9W/ie0w8Z6JtIqt8Yg7PhIJ8XR4ZZhALhkTFj70OXD1cGKIkCbIQTpgwg0dBEkaoCeGIhPSJip1AEUIMWeHBwIRlUkg0bRPEAXt8ZcMUQcBEwoAPQfSJUDDq0jw80TuEBMFRmKI4hJEXDfzUv3ngwxZdr1fXr0PoImOysEbaQBuXw0Ab3LohJBEM7D5IhYrY+yH86XS9NuN9TBZKydcDBtDBtWPC22ChZV3ffXpKSMHkquix2OgJVOiDbi/YHVOs3Cvs9EnYLXOs1DPs8EnYLfdIe2fZMcn+xvT1z32dbdw0+eSmcNy5J+yWOTboGXb+LOyae6zYO+z4u7B7HmGGMelEVJZYLAjmcJF/Rng735YYzZnIkC6GRMGxKDDkLMhCEwkEg7+IlqWfffLiFlr3SQihwXtgCD8UhxK6XC6uOYNo4EMUecHAhxrKPQv88qFLPhcL4vBEYWYJ4cCVMznVekh2bMMRDQKCD1fkhQKt/T7pdn5dHOIoTqDsj+dFAR0Z/wVElJsgDWcUhI5cOMB4u76zxvy0swbrf96Nc9tNr/eFAF1B7pyfsmaIla3hjf5ZCuqpgqpSMuymVyigtwqoQi2wq95hp17jyXqJpbrr2XHaZ8eb2Xu3lyzXeXO79D46dtLrgm4gBVWlBthdr1JAjxVQhdpgl73Ljj3Hk/YWn3Rb48L+xIw9CUZLR6GJEsN5tM9UDoJpT4IoFFGjJsWBe3+ADW1kDf8SMuQokGibxgoW0i6XUoakx4NI0IZ94nVt2w4CgQGkSl8IWVowAN4MT/TgAKPPWrv8BMJAQsKetS4sB6xRvm3bIA4YbdA5F4sgQGgDSA1jJAQMtAGMMBBaQFxsOCMYQAsnFBgDY2QqCEwIAa+t84NtEzsGzH4GrILV6x7hanUeFSE5xgQXpaAPJBzkF3P18AFSNDw9pXOCM3SCJtYMT08NHPgsFda0ukOIFNaZa3KiptYMT1NNHPxsHbx5R4OnqyYOeLYKaZJUKrIT5xhn2LehhLSzsU7l4ZlqjjfQj0MOzQsGXsCQUj4tGMQ5CeaWWU8BAaVk4nEQiw6xWDDsk+crWC4M0RyrxUiJK+7favFhimzHXND3vUuYbGCMz2fgPAJkFJbIhQPS2gB9b70HhIEwdplxuRGskR+QkMHwr/t+Xgx4SiTIlqvIqyC0cPhg4BMtI3KpMbPb5suklMFDYpEY72Qd1v1ekg/h6SkdniFCSLnEbs2PeP031nJvuC91bCk53kwp5JdzKbA7ioOnpEROflZO3vyS4akpmaOenWd+68+PSR95RSop0WttQxkZM7ygfKc7pbPRKmVfYh+LA+k05Bd4FI7IeyJM7DsSAaR04ZeM+zyEFQr7OKHCe0QkSZGdcOHD7wPrCwZAJBoIIcRSIYqmyHMLaK2hlLJv4fe9FRScEBBvE4ckEjAQAjBGBgEiFhyMskb+WBCQUoRlfp/7SZKjMia2VU96GPjkyt6LIhUK7gsPTaPQ9zSqEUIIIeR1lJKL/w5ZfoD4YYmFtO/+aG2q1CfHdyuMyOeKXON6IQPs2rVhDwNgN2wAu3htTtzDJ2761mzV1fIDY+46dfyg1ILGpFJKaK3RNCrYW9OXX8Y7x14LSqqRQBBPY+N9kt8gEgmEEBBSBuEBsJFVgsFfqtF+bdsGQ78/hp0OIYpyYWBq6nPrriUW5KGJgBU9DSYOPpqPExV7DwNv2AcQRAMpDbQWMNJAaolbdxsnNxYGCuqOEGAg5BCqqOv7ebHgjqgAo6LLMPIQcBe3CSLCICb0fT9Sv3LxwE+mXGsIIYQQ8jqfv0G9wU+LtQ4xM5Zcxzj+iA+M5+8WvyL7/bZf58h1eBrQogKA3fAi7K5XOXGPnbjpn8Buu88yCegrHouWdcj1j7rTF+JIfTkek5ponYTuNVTj3tY36XdsXKNUUBCw4Y+Cl4FbmAgHyEIRRcmQZSQUiCmhwW+nZLB5+5BCgE2kPCRBboacBdKGKDLGR+nxiZfVSDDYwrMgZzPRwOPFAX9yQziiJAyRTZbcNE3wOJBCQhsNLQwuUkwkRtYAgHlPgfSvTQSELhMMcrEgXTfnKTAnHMDnZEC6LzBc5IkQgd3uN4QQQg5ISYJ0ec+3ezXacGBWWMcUVh1HAbUqoAoxS1SnpPvDlhR2KnfgpD1w0mbHsAuA0/XCyZo7xx7d8JxwUMhYFCjyWimwSiimVoVUI+aTKuWeBn7Wehj0wQgfrKYGMy9oR+PbJBGyC08Ulttl4zwHdt4b7OOQRkrdz28Qcg+4Awfjv8tR0DRNmJdSuhfigcslzXvg7x1SyiFp8w5sLhoAqaeB7xCtDQCdqCh910O7ZRoaMkqA7EUC651hy/MuH7HRP86LMPcn1eC10HVjAQGR54GKchoMIoHfZnoaEiHPeBnMXeSEkI3gl+40LJfws9KLppJqV1JNR121DVRS7UqqGVFZjc0aiZAr64NPOWBzD9gkx3FblnDQZtberGXeOgeq7omKql5RVR311RhAddWurLqoqcbWK2CsGPgl4a39zK6a7Be/nB2FD/KzQ74EYd/0n0iALKVKcx1EosGcEGBt2BJKyfDSu10uE48Cn6MghB0SMhIm4pwJMnpm7CcY2KNnrJnXYA6jrYHeew/kf9aQP53nIF7mt/Nv+edhh1IBIfImmPFIsKGSgFgA6Ps+XJTB62DCuyAWEmwyZrdtNlEzngZ9r9ftdEIIORDL/RBbm3oGbh9zgKYeoAk4SivucoAm7tmE0j0N6jq9ddX2KSprUmXVRY01vkthzVlqfFhYs97kGK14moM09yDNwJFacpeDNHOPZkzaRiMRYBSTJVsnrVXfEXsTDJ+VSsPNe4FAyilvg0EwGEQCn9Ng3tNgKhGy90CYy1MQ7xdEBLGtXDCVzwDYydMgR0gBGHcCzVg88HGd+r4LXglCaBjj58VILEjLAGBckuUJcWBOSJBChu37rgcgIBubqVsK6RwcpsWCeFl+sbsljhkl7SA3G0JIuQQvp7U44H3sgE1yHLdli3Dg7jlw03D01r1N1i33PQ0q7sNCql5INVBSTV6ikGovWY3XDNmFdEAtHLi7Dtw0HL11i3DwLjp48xznaOVbBM/XzK4K98wcRWUZ5ryRXfd6yAkAzCY89nZapZokYXHwJgi5DKJ5WFHjnljgDf5WiMgSKGcigVJqJC7EbdkzHFHOZD328Dbw+LBDc14HRhv0uh8JA1ob9H2XiAQGQ2LlqaTGj0SD8XZA33euk9IL+d5n6zUwLJ8PRzTM0dOAHIm93mI8z2P5PC3dhRN174mairO1dlNO1rW1N3etZ8i8MoEAABMVSURBVPQ2/VJw729Qte1aX2A/b1SltQ5Tj4fkHAVeE0fkhN18viafr8WbctLurbHZKvYmcC9hj56V43euQ0ggJdVDTwOfCHky9FAehiha1jTT3gM+xBCisEaJGAABFe07Sposx/kR9hAM5rwMgEI8DWKkS1Dsp6M/YcMMxdva3AgGgBpt770QfKghYwSEK2dKNLgnGNjpOM6W3U3bE+vyK5jgGTN4GRjMhyOKZ+lpsB/D23Y8AVVw0tN00mY7zt364jnx6Tlx0yPYC8XxxClZ3etsioUulWWK2eG6Xbj9UpbyPtrBOfkt7uTNB3ugEnia2AUA2AuFM3F6pFLRS975Sy3T59MmSNZomjbWB+wk2MF9UmETDPx5cuNcKFBSpUb88IfE4O+PE4sBSqkgYAzb5qLD4FUQ8ixsHI7oWWZrtKe3QVSHyXBFab6DHkCcg+C+8X+c6HjG0wDTy/u+t+4sQFC/puetkGARePWmtbenwb23znp9bC+I+t/8eYXdv+ZkC3iaA+yKGPbGYeGpHcEuyRl6RMn7iZCf77vPernEH0qfwGsuhr1xSnjaE9gdOeyRU8HTPYJdkqKil8KffaHFvygO5EIAMHgXDJFe7Py0N0EuICilIsEgFQumPAT8X9u2MNpASJ8E2U5jYQFAIjrsGY7onpcBULhoADhjPe6EK3KiQt/3bnsAuCM0aANtvMgwDmf0SESIkyPHQkG+zHpB2GWpAJB1q/84cSaM3vcUCL61tC9FfAPJnvASILwKCDkhG3/tOd4jCXzskAxeEmQaXhmEnJ4FbwOT49G4/MnhqgvxM1rvBIP4heAk4fE430Ew6iP2MMAQRigRGYBGNUmOAy8meAaRwIsHg3dCLDrszSPRYDY8kRBClCAcxCqMFwhyfIdb4cAa+2fbLQFpdQAI0URCwFzYIjESFJ4VC/Kpa9FQF2M/ToYqAiDU/hcQ2RGe/tPDS4DwKiBkH1YZxL8wqn5tAP7ZcL1oD8vdf4nUC7vuU9iDpHJ4CX8Mu3Ap6uvJu2OjQsdzaxzm9Rq934bQ5+MI7pPl21D0mBENfHnRG/xRSCC/fzwF4MIXjUMIDduJJG+BFGlyZACjvAVCSEghRtvVIBgAD6wRJYgGMXOeBv6v7/tgvPeeBv5zvi0MQkLleP/B0B/lOUB2DLwmFhgDaN1PNCiZhIU+LhchhBBCzsvkD5aiYsEvW9LqLFjVI/XfIqLB/s0oDnZJDnuEFAYvyVnYNfdg75yFVY26xY3nly/tVaSUM4LBuF5C2LevhQ/xE1ZEZYVFIlquQviiYbkTAqQPRxSLBRP5DmYEg0ehi0LuApQhGADPiQZ3EyGX4m3gidvjExxPiQEGJngeuJf503IgoI0eJVsWQgLGoOs7CIjgdQAjIg8EYC40kVIyEyrs8tTTICO60Pf+khJCCCElkg8i12D9J/BCR1hojLncUPWJkko5dx81OvMG/aSolUp6FykWEA32b8Zd9hhh79clpf6eKPwiIc9T6iX2Kk9ekkdp7vMYflvvcr7eKcXA+TEbfJm3HpMue2b2Pc/+994Qo2U6WksIY+S2lZlwIKQc5TXwK5WUibCQhxwaiQUuiXHuKZD/BaEAdvtgG8a0d0NNPKxxSaJBTBAJgPBW/uAFMPZAuOd1MJ/TwGRlAnoiEbIXH/x2U6LBI08DmcXvoqcBIYSQGhBvGxyLHF7Uy07dud9Z5PWzFIuIBgtwjDN6jFaQjTjA5XKAJkQcqzVH4v2x5j14vldhx27lmLRu/HjURP8D7uOcYBDKkBPJkKN5pfLtfY4BNSQ7joQELyAoNe09IKW0HgchB4JA06hR+aXkL4h5xssAqFg0AFLhYORx4JbFCZGnww/NiwexYOCN+Frrh2JBLhrYRMiPPA3S9bqnaEAIIWQMk5ZuTEGjoIKqgtJqQzJeOD2fhCcq/yoov4ZkYQo/5YVXL6Kemm7JJyJrOT1aTk3IkxR2ysqqTlm1IXd4cKqklGPBYOpF6yzMu18+jGenRQMBAZmJBkqpVCSYmB/nKPAJjYdQRlMhiZIQSYUJBsCCogFQtnAAIPE4uJfzwG8bxIMZ74KRiDASEkR0bH03ZBGAkWgQJ/iYU9HoaUAIeUT8ICr3Jl1uzcjGFHwpFFw1lF47sjIbnP7hR9pe8Bqvjp1PWRlXTBm1IA9Y4TTx5Y2KKfhrW3DVIuqoJdmAFS4FOx5NBQNvL82TJJtkP5tseC5XQboMiWE/DkM0tSwXDPJQQ3NiQenhiJ4VDICDiAbAfa+DOe8DOwXmPQ/GHgje+wAG0HZF+JyHLYrncxEgjddF0YAQ8h784XISin8KWyqpJmqqKamYSi4z8YGnQTWNPAIbdPU2Z/M418w6IVPmOE6/kcqo7NKrrLqoscakYgq+3JIILJFNdT5BMtx6AWN87oBQWhqWSEpoY0J4otyrwC9TUiWhhkSUGDns57bPBQVAOAGjbMEAWEE0AOoQDoBUPIg9D+J1iRgQhQ+aWz/Oj2CXw00G74KJpMcTosEzngY9RQNCXiLPC0JOShVPqpQKq4xaa03IJJVezktVOw1PVGlnbMVC3bNcL+9/vh4bzvevIyGbUOmlXmm1UXPNCXlI5Zf3O9WXXjSIBQNxP7KCtwGlNvDBU8CXa7SBkMKWF9al24VExlH+gjifQXyc3MPAhygCrF34KIIB8GJ67JqEAz8deRu4CzBeprWG1tZrYG67+LPu9WQYotA9BtDmjtF/TiyI1tHTgLwLjedkliru4NNUXHVH/S0gZHMq/9rUUv3qxw0vdvTr5+XxHiX/OCRkV2q5Ec5QefUdx2gFIUVwkK9Tic3w41Fvf83zD1iEjzwEwNpN89wBcSgin4d27AkwFgyAwXsg3jb2MvBlTiVFrmEs+KpgABxUNPDEhnfvdQCkYkK8zhgDo9M8B/H2XjiIEyTbKWAFh2EqhRhEiXsCwhN1J+/xSWI/chKquqNNc4Am4CitIOTwHOSrepBmOD5vDcdLhGzAQW48B2mG41itIeSUHOxrfLDmOJ5rlTfw21BDz5mqp5Mfp5+9d4HfPhcKEsEgSpaciAROiMjDFIW/SKgomdVFA6A+4WAqp0E+nwsKPqeAFw/y/caiQeRCE02FFKH8oULJBKMvkEEVFxshB32ikQPAS5PUC69esj2Tvx+mnWEfLqnhLStyYHgLJRXDy5fUDa9g8hnJGHLSLiqG/9G6/OWXIVfBOMdBbPRPBAAIG75oxqsgbBd5FNTkYQC8JxgAb5qnaxMOgHGuA7/Mf54TFoZ1gA9fFCdQjsWBIYTRsK0vz4c/mq6cXRPUtEfhjQghhBBCNiaNXV7dUPB1nmzi8z1RZp+9l8y1zLYQQsjTHPQ2dtBm4cgtI88xHq+c5JpYfDz6+tZbMJzfF8JCOnts7mkw5YEQCwX+c56XIE+QfG/7WsQC4H3BAPjgnfbahYN74YemciHkQoJw4Yf8/kM5QC4Y+H3SykznNfDn0ooMhBBCCKmBTePCfzBE+Gx0wbHJpmx0nqvPaUBSKvuaVlZd1FhjQkihVHo72bPa1l5WacfVzAZj0tnxqElnpRCJLTX3NMi9BeLQQUqp5KVt741wL19BHC7pbIIBcDLRAMCkMf+ukBDN5zkSRsLBHU+DJIRRhBRytMyXTwghhJD9qGlAuBsLjgaXH1hWOVTdnPc8Dd6B54OQQ1LgV7vAKqHUWpF14BhyBxb+ii1bHL//j3jG02DqeyWEDCGL8vBBfhp7DxhjkjwFg0fBkBw53nfK26AmdhMNgHqFAyD3Dnic9yCez8MbxaGKvACQhia6IwAEdxok+9PTgBBCyJZ8/LbxSo+t9Z6GfM6SAlnxspwrmp4GFbLD7Wv7Q/IeTY5FbYam6qhuHLp+6YQswkZj09F4NIvOIp2oYOINME5ODMTeBdPhidK8BHJSLJibr4lPBQNggZS7RxIOnp0feycAyMSCZD7LUZCft3h/Dz0NCCFkPWp74JMTs9Eoa5vDVDtkPDTygacBhTtCXmQH8a+k0h/dU5Y/YhlHIeTQbPg12u5QvDeUxFwUFuD+b3dr9E/FATfnlqUeBLGwIOR9oSA+bm32gyUEA+DkogEwbeSPPQmm8hbkngZz29p5wGidJjrGtFAQLzf0NCDkJQTflCRLwUExIaQGFvpa8/m5Ih+eo89PMe/9ZGGevKR4X/mAQ45Dtz8aIWRH3vi6ixl7aQg/NINUsVCdigfeiyBsG4UamvRQiOallDDGVCcWeIoRDYD6hQNgnOtgTjDwXgPTAsEwn3sK+M+T520i1wE9Dcg98mQvdznswHOfIxJCCICThAfZ76hkO5IxxQun+7Urg9dR7Tz125NjTkII2YedblH73Rl5Tz4a7xjpc7vYOOeASF7e9ttPhSnK969VLACWEwyAhUQD4BjCAZCLBQAwFg9seCK7bi6PwdR0/qBprK6n9iGnp+abGKmEUxhFea8lhJybQ40nZm7p9+/06dpD9QchtXGKsef+RyaEkNIQQgT7qh2LiZDg+OF+di54FXgBYiqJcS4K5ALCuNy6WFIwABYUDYBjCQfx1M/HooE/D4+EgnuJkIfyRfQfC5+VF9j47NEdkhBCyG7s+FigOEZK4iXvxaU4hWGQ3ztCCCEvsPNjgx6tZE+klNBazyY8zo393p6aCAMuT8GUYDDadkJAqFUo8CwtGAArmKePIhwA0+LBVD6De94Gft1suKGJ0ESEEEIIIWdmtUG7ufvx7tKjUvsPJFI5BXzdCqiCo5yaEEIIWRcRmWM5Hn1tPBp7JeR5CuY8DPLjpOGQBi+FWllDMABWeqf9SMIB8Jw3Qb5tLiT4fAizAkHihsPwRIQQQgg5MveGoBwDbQlFA0IK5nB5Inh/J+RT+Nx+giduNY834f1qS+5d18+sk0IGm+qUSADMhSKiYHC37LUKPqpw4OfnEiDfm88FhbnzmpdPCCGEkPI41Y+2J4clTI5bH6e6jgkh67HgLX35pwOfN+RYnPbZvcp49L09yLI8uqbn1geRwABCjsMMpaGHBoHgKN+hNQUDYOXo+UcTDoB5g/5oeeZVEIcnEkKE7efO72w4I0IIIcVylMEHIYvz4ojw/QHk4Yaeq8P7FiFkVz64bb+yK291hBAAHJMWyrueBlPeA4/mjzL2XVswADZIuXtE4QCY9yjwn/NlWuuQ2ANIL9KpLqJoQAg5Mkd5UBNCDsybI9jaflw+TIRMF39CyDMscq94f+tn4PiTEFItm49LP9/7FXyOAeC5e/XU9nMCgX9x+0jPgC0EA2AD0QA4rnAATIsH9wSF6ULGuQ4O3GWEFM9L998Xvqp0kySEEFIa1fyAmngkMnHg+lRzfZwJjj0JIYQcDGvYB/xz6BWvgHzbfB8BsZH1exu2EgyADbvtyMIBMO1tMPf52a6oscv4w4KQFVjVhbK++wwhhJDl4NiNEDJi9fAdHH8SQggZ8N4Afv7edlPz0+uBQ6kF2FYwADbuvaMLB8C0of/ZxMbGRCdEzJdXPnOXVY1tIYQQQgg5LuG3h/EjtZrGaxxzEkIIIYTUTj4enTKNx9vkQ8BELMBMAZWztWAA7CC5nEE48NzzLohVtHwffx2cqKsIIYQQQhaFb9A/B8ebhBBCCCFkT94Zt6dCwbFCEOXsIRgAO3XpmYSDmCOHJSKEEEIIIYQQQgghhJBPeSWfwZHZSzAAdtRhKBwsuy0hhHzKGR64hBBCUjjeJLXCcQshZFfM5Oz8RoSQWV59pp9lDLCnYAAU4LxxVvGAEEIIIYSQEuBwnBBCCCGE7MVZRIBn2Vss8BRRCQoHhBBCCCGEEEIIIYQQQs5KKYIBUIhoAFA4IIQQQgghhBBCCCGEEHI+ShIMgIJEAw/FA0IIIYQQQgghhBBCCCFHpzSxwFNkpSgcEEIIIYQQQgghhBBCCDkqpQoGQKGigYfiASGEEEIIIYQQQgghhJCjULJY4Cm+ghQOCCGEEEIIIYQQQgghhNRODYIBUIFoAFA4IIQQQgghhBBCCCGEEFIvtQgGQCWigYfiASGEEEIIIYQQQgghhJBaqEks8FRXYYDiASGEEEIIIYQQQgghhJByqVEs8FRbcYDiASGEEEIIIYQQQgghhJByqFks8FTfAIDiASGEEEIIIYQQQgghhJD9OIJY4DlMQwCKB4QQQgghhBBCCCGEEEK240higedwDQIoHhBCCCGEEEIIIYQQQghZjyOKBZ7DNgygeEAIIYQQQgghhBBCCCFkOY4sFngO30APBQRCCCGEEEIIIYQQQgghr3IGoSDmVI0FKB4QQgghhBBCCCGEEEIIeczZxALPKRvtoYBACCGEEEIIIYQQQgghxHNWoSDm9B3goYBACCGEEEIIIYQQQggh54NCQQo7YwaKCIQQQgghhBBCCCGEEHI8KBLch53zJBQRCCGEEEIIIYQQQgghpD4oErwGO+tNKCIQQgghhBBCCCGEEEJIeVAk+Ax23gpQUCCEEEIIIYQQQgghhJD1oDCwHuzYnaHAQAghhBBCCCGEEEIIIRQCSuH/AYTTg89KZ+dVAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M676.13,502.94c-66.22,0-92.91,9.07-112.4,15.7-10.84,3.68-18.68,6.34-30.09,6.34h-166.1c-18.02,0-45.37-41.1-58.37-67.01-1.55-3.08-5.3-4.33-8.38-2.78-3.08,1.55-4.33,5.3-2.78,8.38,3.79,7.56,37.98,73.9,69.54,73.9h166.1c13.48,0,23.04-3.25,34.11-7.01,18.66-6.34,44.23-15.03,108.38-15.03h827.97v-12.5h-827.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 777.99,
    y: 491.92,
    width: 181.17,
    height: 31.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1308.91,499.13l-6.29,4.39v48.83l6.29,4.39c2.35,1.64,5.28,2.54,8.3,2.54h155.42c3.01,0,5.94-.89,8.3-2.54l6.29-4.39h0v-48.83h0l-6.29-4.39c-2.35-1.64-5.28-2.54-8.3-2.54h-155.42c-3.02,0-5.94.89-8.3,2.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 1370.5,
    y: 435.63,
    width: 48.83,
    height: 184.59,
    transform: "translate(866.99 1922.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 1483.63,
    y: 505.79,
    width: 5.86,
    height: 1.31,
    transform: "translate(1993 -980.12) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 1481.05,
    y: 505.59,
    width: 5.86,
    height: 1.71,
    transform: "translate(1990.42 -977.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 1477.87,
    y: 505.46,
    width: 5.86,
    height: 1.96,
    transform: "translate(1987.24 -974.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 1474.04,
    y: 505.25,
    width: 5.86,
    height: 2.38,
    transform: "translate(1983.41 -970.53) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 1469.54,
    y: 505.05,
    width: 5.86,
    height: 2.79,
    transform: "translate(1978.92 -966.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 1464.5,
    y: 504.92,
    width: 5.86,
    height: 3.05,
    transform: "translate(1973.87 -960.99) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 1458.92,
    y: 504.71,
    width: 5.86,
    height: 3.46,
    transform: "translate(1968.29 -955.41) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 1452.87,
    y: 504.61,
    width: 5.86,
    height: 3.67,
    transform: "translate(1962.24 -949.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 1446.2,
    y: 504.5,
    width: 5.86,
    height: 3.88,
    transform: "translate(1955.57 -942.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1439.27,
    y: 504.35,
    width: 5.86,
    height: 4.19,
    transform: "translate(1948.64 -935.76) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1431.84,
    y: 504.27,
    width: 5.86,
    height: 4.34,
    transform: "translate(1941.21 -928.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1424.18,
    y: 504.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(1933.55 -920.67) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1416.17,
    y: 504.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(1925.54 -912.66) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 1408.05,
    y: 504.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(1917.42 -904.54) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1399.83,
    y: 504.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(1909.2 -896.32) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 1300.34,
    y: 505.79,
    width: 5.86,
    height: 1.31,
    transform: "translate(796.83 1809.71) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 1302.92,
    y: 505.59,
    width: 5.86,
    height: 1.71,
    transform: "translate(799.41 1812.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1306.1,
    y: 505.46,
    width: 5.86,
    height: 1.97,
    transform: "translate(802.59 1815.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 1309.93,
    y: 505.25,
    width: 5.86,
    height: 2.38,
    transform: "translate(806.41 1819.3) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 1314.42,
    y: 505.05,
    width: 5.86,
    height: 2.79,
    transform: "translate(810.91 1823.8) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 1319.47,
    y: 504.92,
    width: 5.86,
    height: 3.05,
    transform: "translate(815.95 1828.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 1325.05,
    y: 504.71,
    width: 5.86,
    height: 3.46,
    transform: "translate(821.54 1834.42) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 1331.1,
    y: 504.61,
    width: 5.86,
    height: 3.67,
    transform: "translate(827.59 1840.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1337.77,
    y: 504.5,
    width: 5.86,
    height: 3.88,
    transform: "translate(834.26 1847.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 1344.7,
    y: 504.35,
    width: 5.86,
    height: 4.19,
    transform: "translate(841.19 1854.07) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 1352.13,
    y: 504.27,
    width: 5.86,
    height: 4.34,
    transform: "translate(848.62 1861.51) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 1359.79,
    y: 504.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(856.28 1869.16) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1367.8,
    y: 504.13,
    width: 5.86,
    height: 4.63,
    transform: "translate(864.29 1877.17) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1375.92,
    y: 504.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(872.41 1885.29) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 1384.14,
    y: 504.02,
    width: 5.86,
    height: 4.83,
    transform: "translate(880.63 1893.51) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1391.98,
    y: 504.06,
    width: 5.86,
    height: 4.76,
    transform: "translate(888.47 1901.36) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 1483.63,
    y: 548.76,
    width: 5.86,
    height: 1.31,
    transform: "translate(2035.97 -937.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1481.05,
    y: 548.56,
    width: 5.86,
    height: 1.71,
    transform: "translate(2033.39 -934.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1477.87,
    y: 548.43,
    width: 5.86,
    height: 1.96,
    transform: "translate(2030.21 -931.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 1474.04,
    y: 548.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(2026.38 -927.56) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1469.54,
    y: 548.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(2021.88 -923.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1464.5,
    y: 547.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(2016.84 -918.02) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1458.92,
    y: 547.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(2011.26 -912.44) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 1452.87,
    y: 547.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(2005.21 -906.39) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 1446.2,
    y: 547.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(1998.54 -899.72) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 1439.27,
    y: 547.32,
    width: 5.86,
    height: 4.19,
    transform: "translate(1991.61 -892.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 1431.84,
    y: 547.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(1984.17 -885.36) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 1424.18,
    y: 547.1,
    width: 5.86,
    height: 4.63,
    transform: "translate(1976.52 -877.7) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 1416.17,
    y: 547.1,
    width: 5.86,
    height: 4.63,
    transform: "translate(1968.51 -869.69) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 1408.05,
    y: 546.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(1960.39 -861.57) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 1399.83,
    y: 546.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(1952.17 -853.35) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 1300.34,
    y: 548.76,
    width: 5.86,
    height: 1.31,
    transform: "translate(753.86 1852.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 1302.92,
    y: 548.56,
    width: 5.86,
    height: 1.71,
    transform: "translate(756.44 1855.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 1306.1,
    y: 548.43,
    width: 5.86,
    height: 1.97,
    transform: "translate(759.62 1858.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 1309.93,
    y: 548.22,
    width: 5.86,
    height: 2.38,
    transform: "translate(763.45 1862.27) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 1314.42,
    y: 548.01,
    width: 5.86,
    height: 2.79,
    transform: "translate(767.94 1866.76) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 1319.47,
    y: 547.88,
    width: 5.86,
    height: 3.05,
    transform: "translate(772.99 1871.81) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 1325.05,
    y: 547.68,
    width: 5.86,
    height: 3.46,
    transform: "translate(778.57 1877.39) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 1331.1,
    y: 547.57,
    width: 5.86,
    height: 3.67,
    transform: "translate(784.62 1883.44) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 1337.77,
    y: 547.47,
    width: 5.86,
    height: 3.88,
    transform: "translate(791.29 1890.11) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 1344.7,
    y: 547.32,
    width: 5.86,
    height: 4.19,
    transform: "translate(798.22 1897.04) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 1352.13,
    y: 547.24,
    width: 5.86,
    height: 4.34,
    transform: "translate(805.65 1904.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 1359.79,
    y: 547.1,
    width: 5.86,
    height: 4.63,
    transform: "translate(813.31 1912.13) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 1367.8,
    y: 547.1,
    width: 5.86,
    height: 4.63,
    transform: "translate(821.32 1920.14) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1375.92,
    y: 546.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(829.44 1928.26) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 1384.14,
    y: 546.99,
    width: 5.86,
    height: 4.83,
    transform: "translate(837.66 1936.48) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 1391.98,
    y: 547.03,
    width: 5.86,
    height: 4.76,
    transform: "translate(845.5 1944.32) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 1375.33,
    y: 435.63,
    width: 39.17,
    height: 184.59,
    transform: "translate(866.99 1922.84) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1320.11,539.99l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1320.11,530.54l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1320.11,521.08l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1320.11,511.63l-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.15.11-.24.25-.24.39v1.42l2.35-1.7c.39-.28,1.09-.28,1.48,0l1.72,1.24h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.86-2.06,2.37,1.7-.12.07,1.17.69.18.13h.02s.02,0,.02,0l3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38h0l1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.72,2.2,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,3.72-2.2c.38-.22.97-.22,1.34,0l2.33,1.38,1.39.82,1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l2.33,1.38h0s1.39.82,1.39.82l1.39-.82,2.33-1.38c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.05,1.8c.38.22.97.22,1.34,0l3.05-1.8c.38-.22.97-.22,1.34,0l3.72,2.2.04-.02.03.02.29-.21,1.03-.61-.1-.06,2.38-1.71,2.46,1.77h0l1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.86,2.06,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,2.86-2.06c.39-.28,1.09-.28,1.48,0l1.72,1.24,1.14.82,1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l1.72,1.24h0s1.14.82,1.14.82l1.14-.82,1.72-1.24c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.12,1.53c.39.28,1.09.28,1.48,0l2.12-1.53c.39-.28,1.09-.28,1.48,0l2.36,1.7v-1.42c0-.14-.08-.28-.24-.39l-1.73-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-2.86-2.06-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.82,1.31c-.36.26-1.01.28-1.41.04l-2.3-1.36-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-3.72,2.2c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-3.72-2.2-1.39.82-2.33,1.38c-.38.22-.97.22-1.34,0l-2.33-1.38-1.39-.82-1.39.82-2.28,1.35c-.4.24-1.05.22-1.41-.04l-1.81-1.3-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-1.14.82-1.72,1.24c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82-2.86,2.06c-.39.28-1.09.28-1.48,0l-1.72-1.24-1.14-.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 1302.62,
    y: 496.59,
    width: 184.59,
    height: 37.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1524.2,504.54c0,7.74-1.4,14.01-3.12,14.01s-3.12-6.27-3.12-14.01,1.4-14.01,3.12-14.01,3.12,6.27,3.12,14.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 1500.18,
    y: 488.18,
    width: 20.9,
    height: 32.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 507.05,
    y: 517.07,
    width: 571.32,
    height: 13.18,
    transform: "translate(43.13 -60.06) rotate(4.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M60.34,342.27h301.54c13.6,0,24.64,11.04,24.64,24.64v100.14H60.34v-124.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M318.69,529.8h-99.68c-19.41,0-38.4-3.9-54.92-11.27-12.7-5.67-27.33-8.66-42.31-8.66h-61.44v-19.3h61.44c19.4,0,38.39,3.9,54.92,11.27,12.7,5.67,27.33,8.67,42.31,8.67h99.68c12.07,0,24.18-2,35.02-5.78l19.12-6.66c14.08-4.91,29.77-7.5,45.38-7.5h1085.9v19.3H418.21c-12.07,0-24.17,2-35.02,5.78l-19.12,6.67c-14.07,4.91-29.77,7.5-45.38,7.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 60.34,
    y: 432.87,
    width: 1443.76,
    height: 62.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 60.34,
    y: 415.18,
    width: 1443.76,
    height: 62.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M262.38,451.57c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM262.38,589.56c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M354.68,545.18v-4.71h-5.81c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.81.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.81-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.23-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM262.38,589.56c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M262.38,460.1c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM262.38,589.56c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M262.38,484.98c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM262.38,592.35c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M262.38,490.38c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM262.38,587.67c-24.96,0-45.2-20.24-45.2-45.2s20.24-45.2,45.2-45.2,45.2,20.24,45.2,45.2-20.24,45.2-45.2,45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M262.38,494.25c-26.63,0-48.22,21.59-48.22,48.22s21.59,48.22,48.22,48.22,48.22-21.59,48.22-48.22-21.59-48.22-48.22-48.22ZM234.25,570.27c-2,1.15-4.55.47-5.7-1.53l-7.25-12.55c-1.15-2-.47-4.55,1.53-5.7,2-1.15,4.55-.47,5.7,1.53l7.25,12.55c1.15,2,.47,4.55-1.53,5.7ZM237.19,517.93l-7.25,12.55c-1.15,2-3.7,2.68-5.7,1.53-2-1.15-2.68-3.7-1.53-5.7l7.25-12.55c1.15-2,3.7-2.68,5.7-1.53h0c2,1.15,2.68,3.7,1.53,5.7ZM268.22,584.9h-14.49c-2.3,0-4.17-1.87-4.17-4.17s1.87-4.17,4.17-4.17h14.49c2.3,0,4.17,1.87,4.17,4.17s-1.87,4.17-4.17,4.17ZM271.03,508.38h-14.49c-2.3,0-4.17-1.87-4.17-4.17s1.87-4.17,4.17-4.17h14.49c2.3,0,4.17,1.87,4.17,4.17s-1.87,4.17-4.17,4.17ZM302.04,558.63l-7.25,12.55c-1.15,2-3.7,2.68-5.7,1.53-2-1.15-2.68-3.7-1.53-5.7l7.25-12.55c1.15-2,3.7-2.68,5.7-1.53,2,1.15,2.68,3.7,1.53,5.7ZM301.92,534.45c-2,1.15-4.55.47-5.7-1.53l-7.25-12.55c-1.15-2-.47-4.55,1.53-5.7h0c2-1.15,4.55-.47,5.7,1.53l7.25,12.55c1.15,2,.47,4.55-1.53,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M262.38,491.92c-27.92,0-50.55,22.63-50.55,50.55s22.63,50.55,50.55,50.55,50.55-22.63,50.55-50.55-22.63-50.55-50.55-50.55ZM232.9,571.61c-2.09,1.21-4.77.49-5.97-1.6l-7.6-13.16c-1.21-2.09-.49-4.77,1.6-5.97,2.09-1.21,4.77-.49,5.97,1.6l7.6,13.16c1.21,2.09.49,4.77-1.6,5.97ZM235.97,516.75l-7.6,13.16c-1.21,2.09-3.88,2.81-5.97,1.6-2.09-1.21-2.81-3.88-1.6-5.97l7.6-13.16c1.21-2.09,3.88-2.81,5.97-1.6h0c2.09,1.21,2.81,3.88,1.6,5.97ZM268.5,586.94h-15.19c-2.42,0-4.37-1.96-4.37-4.37s1.96-4.37,4.37-4.37h15.19c2.42,0,4.37,1.96,4.37,4.37s-1.96,4.37-4.37,4.37ZM271.45,506.74h-15.19c-2.42,0-4.37-1.96-4.37-4.37s1.96-4.37,4.37-4.37h15.19c2.42,0,4.37,1.96,4.37,4.37s-1.96,4.37-4.37,4.37ZM303.95,559.41l-7.6,13.16c-1.21,2.09-3.88,2.81-5.97,1.6-2.09-1.21-2.81-3.88-1.6-5.97l7.6-13.16c1.21-2.09,3.88-2.81,5.97-1.6,2.09,1.21,2.81,3.88,1.6,5.97ZM303.83,534.06c-2.09,1.21-4.77.49-5.97-1.6l-7.6-13.16c-1.21-2.09-.49-4.77,1.6-5.97h0c2.09-1.21,4.77-.49,5.97,1.6l7.6,13.16c1.21,2.09.49,4.77-1.6,5.97Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-100",
    cx: 262.38,
    cy: 542.47,
    r: 30.8,
    transform: "translate(-332.85 636.39) rotate(-73.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 262.38,
    cy: 542.47,
    r: 18.8,
    transform: "translate(-306.73 344.42) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "264.85 563.59 260.68 563.59 258.6 567.2 260.68 570.82 264.85 570.82 266.94 567.2 264.85 563.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M264.81,567.2c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "279.06 555.65 276.11 558.6 277.19 562.63 281.22 563.71 284.17 560.76 283.09 556.73 279.06 555.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M281.59,558.24c.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89.8-.8,2.1-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "283.5 539.99 283.5 544.17 287.11 546.25 290.73 544.17 290.73 539.99 287.11 537.91 283.5 539.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M287.11,540.03c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "275.56 525.78 278.51 528.73 282.54 527.66 283.62 523.63 280.67 520.68 276.64 521.76 275.56 525.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M278.15,523.26c.8-.8,2.1-.8,2.89,0,.8.8.8,2.1,0,2.89s-2.1.8-2.89,0c-.8-.8-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "259.9 521.35 264.08 521.35 266.16 517.74 264.08 514.12 259.9 514.12 257.82 517.74 259.9 521.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M259.94,517.74c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "245.7 529.28 248.65 526.33 247.57 522.3 243.54 521.22 240.59 524.17 241.67 528.2 245.7 529.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M243.17,526.7c-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.09,0,2.89-.8.8-2.09.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "241.26 544.94 241.26 540.77 237.65 538.69 234.03 540.77 234.03 544.94 237.65 547.03 241.26 544.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M237.65,544.9c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "249.19 559.15 246.24 556.2 242.21 557.28 241.13 561.31 244.08 564.26 248.11 563.18 249.19 559.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M246.61,561.68c-.8.8-2.1.8-2.89,0-.8-.8-.8-2.1,0-2.89s2.1-.8,2.89,0c.8.8.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M272.87,542.47c0,5.79-4.7,10.49-10.49,10.49s-10.49-4.7-10.49-10.49,4.7-10.49,10.49-10.49,10.49,4.7,10.49,10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1293.02,516.84l-5.55-10.65c-2.55-4.89-8.58-6.79-13.47-4.24h0c-4.89,2.55-6.79,8.59-4.24,13.48l3.27,6.27h-108.53v-.47h-17.75v.47h-108.53l3.27-6.27c2.55-4.89.65-10.92-4.24-13.48h0c-4.89-2.55-10.93-.65-13.48,4.24l-5.55,10.64c-2.55,4.89-.65,10.92,4.24,13.47h0c4.41,2.3,9.72.96,12.6-2.91h25.15v2.85h9.89v2.85h15.67v2.85h17.31v2.85h22.27v2.85h21.4v1.86h17.75v-1.86h21.4v-2.85h22.27v-2.85h17.32v-2.85h15.66v-2.85h9.89v-2.85h25.16c2.88,3.87,8.19,5.21,12.6,2.91h0c4.89-2.55,6.79-8.59,4.24-13.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M386.51,399.5h0c-2.95,0-5.34-2.39-5.34-5.34v-178.18c0-2.95,2.39-5.34,5.34-5.34h0c2.95,0,5.34,2.39,5.34,5.34v178.18c0,2.95-2.39,5.34-5.34,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M397.65,203.98c0-4.55-3.69-8.23-8.23-8.23s-8.23,3.69-8.23,8.23v49.12h16.47v-49.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 478.38,
    y: 413.49,
    width: 12.36,
    height: 99.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1298.68,
    y: 413.49,
    width: 12.36,
    height: 96.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1453.15,
    y: 413.49,
    width: 12.36,
    height: 96.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 811.3,
    y: 413.49,
    width: 12.36,
    height: 96.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 965.76,
    y: 413.49,
    width: 12.36,
    height: 96.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-127",
    cx: 1155.87,
    cy: 542.47,
    r: 39.87,
    transform: "translate(212.36 1402.76) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1155.62,451.57c-50.2,0-90.9,40.7-90.9,90.9s40.7,90.9,90.9,90.9,90.9-40.7,90.9-90.9-40.7-90.9-90.9-90.9ZM1155.62,589.56c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1247.92,545.18v-4.71h-5.8c-.02-.95-.04-1.9-.09-2.84l5.78-.51-.41-4.7-5.76.5c-.1-.94-.22-1.88-.36-2.81l5.71-1.01-.82-4.64-5.68,1c-.19-.93-.4-1.85-.62-2.77l5.61-1.5-1.22-4.55-5.58,1.5c-.27-.91-.55-1.81-.84-2.71l5.45-1.98-1.61-4.43-5.43,1.98c-.34-.88-.69-1.76-1.06-2.63l5.24-2.44-1.99-4.27-5.24,2.44c-.42-.85-.85-1.69-1.29-2.53l5.01-2.89-2.36-4.08-5,2.88c-.49-.81-1.01-1.6-1.53-2.39l4.76-3.33-2.7-3.86-4.74,3.32c-.56-.76-1.14-1.51-1.73-2.25l4.46-3.74-3.03-3.61-4.44,3.73c-.62-.71-1.26-1.41-1.91-2.1l4.11-4.11-3.33-3.33-4.1,4.1c-.68-.65-1.37-1.3-2.08-1.93l3.73-4.45-3.61-3.03-3.73,4.44c-.74-.59-1.47-1.19-2.23-1.75l3.32-4.75-3.86-2.7-3.31,4.73c-.79-.52-1.58-1.03-2.39-1.53l2.9-5.02-4.08-2.36-2.88,5c-.83-.45-1.67-.88-2.52-1.31l2.45-5.26-4.27-1.99-2.44,5.24c-.87-.38-1.74-.74-2.62-1.09l1.98-5.45-4.43-1.61-1.98,5.43c-.9-.3-1.79-.6-2.7-.87l1.5-5.59-4.55-1.22-1.5,5.58c-.92-.22-1.84-.45-2.77-.64l1-5.7-4.64-.82-1,5.68c-.93-.14-1.87-.25-2.82-.36l.51-5.79-4.7-.41-.51,5.77c-.94-.06-1.89-.1-2.83-.13v-5.82h-4.71v5.81c-.95.02-1.9.04-2.84.09l-.51-5.78-4.7.41.5,5.76c-.94.1-1.88.22-2.82.36l-1.01-5.71-4.64.82,1,5.68c-.93.19-1.85.4-2.77.62l-1.5-5.61-4.55,1.22,1.5,5.58c-.91.27-1.81.55-2.71.84l-1.98-5.45-4.43,1.61,1.98,5.43c-.88.34-1.76.69-2.63,1.06l-2.44-5.24-4.27,1.99,2.44,5.24c-.85.42-1.69.85-2.53,1.29l-2.89-5.01-4.08,2.36,2.88,5c-.81.49-1.6,1.01-2.39,1.53l-3.33-4.76-3.86,2.7,3.32,4.74c-.76.56-1.51,1.14-2.25,1.73l-3.74-4.46-3.61,3.03,3.73,4.44c-.71.62-1.41,1.26-2.1,1.91l-4.11-4.11-3.33,3.33,4.1,4.1c-.65.68-1.3,1.37-1.93,2.08l-4.45-3.73-3.03,3.61,4.44,3.73c-.59.74-1.19,1.47-1.75,2.23l-4.75-3.32-2.7,3.86,4.73,3.31c-.52.79-1.03,1.59-1.53,2.39l-5.02-2.9-2.36,4.08,5,2.88c-.45.83-.88,1.67-1.31,2.52l-5.26-2.45-1.99,4.27,5.24,2.44c-.38.87-.74,1.74-1.09,2.62l-5.45-1.98-1.61,4.43,5.43,1.98c-.3.9-.6,1.79-.87,2.7l-5.59-1.5-1.22,4.55,5.58,1.5c-.22.92-.45,1.84-.64,2.77l-5.7-1-.82,4.64,5.68,1c-.14.93-.25,1.87-.36,2.82l-5.79-.51-.41,4.7,5.77.51c-.06.94-.1,1.89-.13,2.83h-5.82v4.71h5.8c.02.95.04,1.9.09,2.84l-5.78.51.41,4.7,5.76-.5c.1.94.22,1.88.36,2.82l-5.71,1.01.82,4.64,5.68-1c.19.93.4,1.85.62,2.77l-5.61,1.5,1.22,4.55,5.58-1.5c.27.91.55,1.81.84,2.71l-5.45,1.98,1.61,4.43,5.43-1.98c.34.88.69,1.76,1.06,2.63l-5.24,2.44,1.99,4.27,5.24-2.44c.42.85.85,1.69,1.29,2.53l-5.01,2.89,2.36,4.08,5-2.88c.49.81,1.01,1.6,1.53,2.39l-4.76,3.33,2.7,3.86,4.74-3.32c.56.76,1.14,1.51,1.73,2.25l-4.46,3.74,3.03,3.61,4.44-3.73c.62.71,1.26,1.41,1.91,2.1l-4.11,4.11,3.33,3.33,4.1-4.1c.68.65,1.37,1.3,2.08,1.93l-3.73,4.45,3.61,3.03,3.73-4.44c.74.59,1.47,1.19,2.23,1.75l-3.32,4.75,3.86,2.7,3.31-4.73c.79.52,1.59,1.03,2.39,1.53l-2.9,5.02,4.08,2.36,2.88-5c.83.45,1.67.88,2.52,1.31l-2.45,5.26,4.27,1.99,2.44-5.24c.87.38,1.74.74,2.62,1.09l-1.98,5.45,4.43,1.61,1.98-5.43c.9.3,1.79.6,2.7.87l-1.5,5.59,4.55,1.22,1.5-5.58c.92.22,1.84.45,2.77.64l-1,5.7,4.64.82,1-5.68c.93.14,1.87.25,2.82.36l-.51,5.79,4.7.41.51-5.77c.94.06,1.89.1,2.83.13v5.82h4.71v-5.8c.95-.02,1.9-.04,2.84-.09l.51,5.78,4.7-.41-.5-5.76c.94-.1,1.88-.22,2.82-.36l1.01,5.71,4.64-.82-1-5.68c.93-.19,1.85-.4,2.77-.62l1.5,5.61,4.55-1.22-1.5-5.58c.91-.27,1.81-.55,2.71-.84l1.98,5.45,4.43-1.61-1.98-5.43c.88-.34,1.76-.69,2.63-1.06l2.44,5.24,4.27-1.99-2.44-5.24c.85-.42,1.69-.85,2.53-1.29l2.89,5.01,4.08-2.36-2.88-5c.81-.49,1.6-1.01,2.39-1.53l3.33,4.76,3.86-2.7-3.32-4.74c.76-.56,1.51-1.14,2.25-1.73l3.74,4.46,3.61-3.03-3.73-4.44c.71-.62,1.41-1.26,2.1-1.91l4.11,4.11,3.33-3.33-4.1-4.1c.65-.68,1.3-1.37,1.93-2.08l4.45,3.73,3.03-3.61-4.44-3.73c.59-.74,1.19-1.47,1.75-2.23l4.75,3.32,2.7-3.86-4.73-3.31c.52-.79,1.03-1.59,1.53-2.39l5.02,2.9,2.36-4.08-5-2.88c.45-.83.88-1.67,1.31-2.52l5.26,2.45,1.99-4.27-5.24-2.44c.38-.87.74-1.74,1.09-2.62l5.45,1.98,1.61-4.43-5.43-1.98c.3-.9.6-1.79.87-2.7l5.59,1.5,1.22-4.55-5.58-1.5c.22-.92.45-1.84.64-2.77l5.7,1,.82-4.64-5.68-1c.14-.93.25-1.87.36-2.82l5.79.51.41-4.7-5.77-.51c.06-.94.1-1.89.13-2.83h5.82ZM1155.62,589.56c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1155.62,460.1c-45.49,0-82.37,36.88-82.37,82.37s36.88,82.37,82.37,82.37,82.37-36.88,82.37-82.37-36.88-82.37-82.37-82.37ZM1155.62,589.56c-26.01,0-47.09-21.08-47.09-47.09s21.09-47.09,47.09-47.09,47.09,21.08,47.09,47.09-21.09,47.09-47.09,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1155.62,484.98c-31.75,0-57.48,25.74-57.48,57.48s25.74,57.48,57.48,57.48,57.48-25.74,57.48-57.48-25.74-57.48-57.48-57.48ZM1155.62,592.35c-27.55,0-49.88-22.33-49.88-49.88s22.33-49.88,49.88-49.88,49.88,22.33,49.88,49.88-22.33,49.88-49.88,49.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1155.62,490.38c-28.77,0-52.09,23.32-52.09,52.09s23.32,52.09,52.09,52.09,52.09-23.32,52.09-52.09-23.32-52.09-52.09-52.09ZM1155.62,587.67c-24.96,0-45.2-20.24-45.2-45.2s20.24-45.2,45.2-45.2,45.2,20.24,45.2,45.2-20.24,45.2-45.2,45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1155.62,491.92c-27.92,0-50.55,22.63-50.55,50.55s22.63,50.55,50.55,50.55,50.55-22.63,50.55-50.55-22.63-50.55-50.55-50.55ZM1182.44,510.83c2.96-1.71,8.49,2.33,12.35,9.02,3.86,6.69,4.6,13.5,1.64,15.21-2.96,1.71-8.49-2.33-12.35-9.02-3.86-6.69-4.6-13.5-1.64-15.21ZM1128.8,574.1c-2.96,1.71-8.49-2.33-12.35-9.02-3.86-6.69-4.6-13.5-1.64-15.21,2.96-1.71,8.49,2.33,12.35,9.02,3.86,6.69,4.6,13.5,1.64,15.21ZM1127.17,526.04c-3.86,6.69-9.39,10.73-12.35,9.02-2.96-1.71-2.22-8.52,1.64-15.21,3.86-6.69,9.39-10.73,12.35-9.02s2.22,8.52-1.64,15.21ZM1155.62,587.69c-7.73,0-13.99-2.77-13.99-6.18s6.26-6.18,13.99-6.18,13.99,2.77,13.99,6.18-6.26,6.18-13.99,6.18ZM1155.62,509.61c-7.73,0-13.99-2.77-13.99-6.18s6.26-6.18,13.99-6.18,13.99,2.77,13.99,6.18-6.26,6.18-13.99,6.18ZM1194.79,565.08c-3.86,6.69-9.39,10.73-12.35,9.02-2.96-1.71-2.22-8.52,1.64-15.21,3.86-6.69,9.39-10.73,12.35-9.02,2.96,1.71,2.22,8.52-1.64,15.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1155.62,491.92c-26.04,0-47.46,19.69-50.23,44.99,1.93,5.33,4.69,10.26,8.11,14.65.3-.73.71-1.33,1.31-1.68,2.96-1.71,8.49,2.33,12.35,9.02,1.33,2.3,2.25,4.59,2.82,6.7,7.61,4.17,16.34,6.55,25.64,6.55s18.03-2.38,25.64-6.55c.57-2.11,1.49-4.41,2.82-6.7,3.86-6.69,9.39-10.73,12.35-9.02.6.35,1.01.95,1.31,1.68,3.42-4.39,6.18-9.32,8.11-14.65-2.77-25.3-24.19-44.99-50.23-44.99ZM1127.17,526.04c-3.86,6.69-9.39,10.73-12.35,9.02-2.96-1.71-2.22-8.52,1.64-15.21,3.86-6.69,9.39-10.73,12.35-9.02,2.96,1.71,2.22,8.52-1.64,15.21ZM1155.62,509.61c-7.73,0-13.99-2.77-13.99-6.18s6.26-6.18,13.99-6.18,13.99,2.77,13.99,6.18-6.26,6.18-13.99,6.18ZM1196.43,535.06c-2.96,1.71-8.49-2.33-12.35-9.02-3.86-6.69-4.6-13.5-1.64-15.21,2.96-1.71,8.49,2.33,12.35,9.02,3.86,6.69,4.6,13.5,1.64,15.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1158.09 563.59 1153.92 563.59 1151.84 567.2 1153.92 570.82 1158.09 570.82 1160.18 567.2 1158.09 563.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1158.06,567.2c0,1.13-.92,2.05-2.05,2.05s-2.05-.92-2.05-2.05.92-2.05,2.05-2.05,2.05.92,2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1172.3 555.65 1169.35 558.6 1170.43 562.63 1174.46 563.71 1177.41 560.76 1176.33 556.73 1172.3 555.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1174.83,558.24c.8.8.8,2.1,0,2.89-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1176.74 539.99 1176.74 544.17 1180.35 546.25 1183.97 544.17 1183.97 539.99 1180.35 537.91 1176.74 539.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1180.35,540.03c1.13,0,2.05.92,2.05,2.05s-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05.92-2.05,2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1168.8 525.78 1171.75 528.73 1175.78 527.66 1176.86 523.63 1173.91 520.68 1169.88 521.76 1168.8 525.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1171.39,523.26c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1153.15 521.35 1157.32 521.35 1159.4 517.74 1157.32 514.12 1153.15 514.12 1151.06 517.74 1153.15 521.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1153.19,517.74c0-1.13.92-2.05,2.05-2.05s2.05.92,2.05,2.05-.92,2.05-2.05,2.05-2.05-.92-2.05-2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1138.94 529.28 1141.89 526.33 1140.81 522.3 1136.78 521.22 1133.83 524.17 1134.91 528.2 1138.94 529.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1136.41,526.7c-.8-.8-.8-2.1,0-2.89.8-.8,2.09-.8,2.89,0,.8.8.8,2.09,0,2.89-.8.8-2.1.8-2.89,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1134.5 544.94 1134.5 540.77 1130.89 538.69 1127.27 540.77 1127.27 544.94 1130.89 547.03 1134.5 544.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1130.89,544.9c-1.13,0-2.05-.92-2.05-2.05s.92-2.05,2.05-2.05,2.05.92,2.05,2.05-.92,2.05-2.05,2.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "1142.44 559.15 1139.49 556.2 1135.46 557.28 1134.38 561.31 1137.33 564.26 1141.36 563.18 1142.44 559.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1139.85,561.68c-.8.8-2.1.8-2.89,0s-.8-2.1,0-2.89c.8-.8,2.09-.8,2.89,0s.8,2.1,0,2.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-89",
    cx: 1155.62,
    cy: 542.47,
    r: 18.8,
    transform: "translate(435.05 1596.27) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1168.8,542.47c0,7.28-5.9,13.18-13.18,13.18s-13.18-5.9-13.18-13.18,5.9-13.18,13.18-13.18,13.18,5.9,13.18,13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M431.14,444.3h-24.76v-33.44c0-4.01-3.25-7.26-7.26-7.26s-7.26,3.25-7.26,7.26v70.4c0,4.26,3.45,7.71,7.71,7.71h31.58c4.26,0,7.71-3.45,7.71-7.71v-29.25c0-4.26-3.45-7.71-7.71-7.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M415.86,474.17h24.76v33.44c0,4.01,3.25,7.26,7.26,7.26s7.26-3.25,7.26-7.26v-70.4c0-4.26-3.45-7.71-7.71-7.71h-31.58c-4.26,0-7.71,3.45-7.71,7.71v29.25c0,4.26,3.45,7.71,7.71,7.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-106",
    cx: 431.65,
    cy: 457.4,
    r: 34.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-107",
    cx: 431.65,
    cy: 457.4,
    r: 27.78,
    transform: "translate(-66.06 841.87) rotate(-84.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-104",
    cx: 431.65,
    cy: 457.4,
    r: 21.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 431.65,
    cy: 457.4,
    r: 17.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 503.01,
    y: 433.02,
    width: 211.04,
    height: 113.52,
    rx: 4.4,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 516.2,
    y: 532.64,
    width: 33.77,
    height: 20.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 528.09,
    y: 429.02,
    width: 9.99,
    height: 122.31,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M533.09,551.33h0c-1.77,0-3.2-1.43-3.2-3.2v-115.91c0-1.77,1.43-3.2,3.2-3.2h0c1.77,0,3.2,1.43,3.2,3.2v115.91c0,1.77-1.43,3.2-3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 591.65,
    y: 532.64,
    width: 33.78,
    height: 20.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 603.54,
    y: 429.02,
    width: 9.99,
    height: 122.31,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M608.54,551.33h0c-1.77,0-3.2-1.43-3.2-3.2v-115.91c0-1.77,1.43-3.2,3.2-3.2h0c1.77,0,3.2,1.43,3.2,3.2v115.91c0,1.77-1.43,3.2-3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 667.09,
    y: 532.64,
    width: 33.77,
    height: 20.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 678.98,
    y: 429.02,
    width: 9.99,
    height: 122.31,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M683.98,551.33h0c-1.77,0-3.2-1.43-3.2-3.2v-115.91c0-1.77,1.43-3.2,3.2-3.2h0c1.77,0,3.2,1.43,3.2,3.2v115.91c0,1.77-1.43,3.2-3.2,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M541.62,432.47h24.4v6.06c0,5.63-4.57,10.2-10.2,10.2h-4.01c-5.63,0-10.2-4.57-10.2-10.2v-6.06h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 553.82,
    cy: 432.47,
    rx: 12.2,
    ry: 8.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M249.69,234.62c1.74-2.14,2.66-4.94,2.3-7.88l-2.46-19.75c-.71-5.71-5.96-9.8-11.67-9.09l-.34.04c-5.71.71-9.8,5.96-9.09,11.67l2.46,19.75c.37,2.96,1.98,5.47,4.22,7.12-4.18,2.64-7.24,7.01-8,12.25l-8.48,58.55c-1.38,9.51,5.27,18.41,14.78,19.79,9.51,1.38,18.41-5.27,19.79-14.78l8.48-58.55c1.24-8.54-4.01-16.58-11.99-19.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M86.08,274.76c-.2,1.92,1.18,3.66,3.04,4.16l23.56,6.41-2.76,10.14c-.38,1.39-1.81,2.21-3.2,1.83h0c-.95-.26-1.92.3-2.18,1.25l-14.33,52.66,21.4,5.82,14.33-52.66c.26-.95-.3-1.92-1.25-2.18h0c-1.39-.38-2.21-1.81-1.83-3.2l2.76-10.14,23.56,6.41c1.86.51,3.93-.3,4.73-2.05,1.02-2.24-.23-4.75-2.5-5.36l-60.46-16.45c-2.27-.62-4.61.92-4.87,3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M123.71,178.36h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.59c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 273,
    y: 178.36,
    width: 63.55,
    height: 113.32,
    rx: 11.09,
    ry: 11.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M273,263.69v16.89c0,6.13,4.97,11.09,11.09,11.09h41.37c6.13,0,11.09-4.97,11.09-11.09v-16.89h-63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M136.22,275.33l-5.79,8.81c-3.08,4.7-8.33,7.53-13.95,7.53h-39.42c-1.09,8.59-1.8,17.08-2.14,25.56-.47,11.93,10.7,20.94,22.24,17.9l127.56-33.58c9.13-2.4,15.5-10.66,15.5-20.11v-17.75h-82.45c-8.69,0-16.79,4.37-21.56,11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1318.42,587.34c-6.07-3.52-23.11-6.5-24.13-33.68-.76-20.02-.79-45.93-1.04-67.43h-3.09v67.9c0,15.09,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M356.34,164.57c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.35,176.26-74.35,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM240.22,281.44c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,280.58c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.36,353.14c-124.03,0-234.59,18.08-306.44,46.31.03,2.13.08,4.2.15,6.24,71.85-28.19,182.35-46.25,306.3-46.25,11.04,0,21.96.15,32.77.43v-6.3c-10.81-.28-21.73-.43-32.77-.43Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 340,
    height: 81,
    transform: "translate(28.8 358.6)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "166.74 439.56 35.08 439.56 35.08 512.41 67.95 512.41 67.95 551.48 75.74 551.48 75.74 512.41 117.71 512.41 117.71 551.48 125.51 551.48 125.51 512.41 137.16 512.41 166.74 439.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M63.55,551.48H29.38c-15.56,0-28.18-39.53-28.18-54.76v-38.48c0-8.95,7.49-16.28,16.64-16.28h45.72v109.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "134.22 487.13 67.95 487.13 67.95 446.96 152.49 446.96 134.22 487.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M126.68,482.53h-46.45c-4.11,0-7.45-3.34-7.45-7.45v-28.12h74.86l-14.19,31.21c-1.21,2.66-3.86,4.37-6.78,4.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 66,
    y: 544.9,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 66,
    y: 541.61,
    width: 61.45,
    height: 6.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1486.41,436.83h36.11v47.75h-36.11c-5.94,0-10.76-4.82-10.76-10.76v-26.23c0-5.94,4.82-10.76,10.76-10.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1498.46,
    y: 522.32,
    width: 22.94,
    height: 17.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 1492.82,
    y: 415.18,
    width: 11.28,
    height: 143.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M1521.58,462.52h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.72v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1522.23,
    y: 463.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1522.34,
    y: 464.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1520.52,
    y: 463.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1520.63,
    y: 464.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1518.81,
    y: 463.92,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1518.92,
    y: 464.24,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1521.58,440.09h0c1.45,0,2.62,1.17,2.62,2.62v13.55c0,1.45-1.17,2.62-2.62,2.62h0c-3.16,0-5.71-2.56-5.71-5.72v-7.36c0-3.16,2.56-5.71,5.71-5.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1522.23,
    y: 441.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1522.34,
    y: 441.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1520.52,
    y: 441.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1520.63,
    y: 441.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1518.81,
    y: 441.5,
    width: 1.25,
    height: 15.98,
    rx: 0.52,
    ry: 0.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1518.92,
    y: 441.81,
    width: 0.83,
    height: 4.54,
    rx: 0.35,
    ry: 0.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 1030.3,
    y: 402.23,
    width: 13.7,
    height: 104.6,
    transform: "translate(366.21 -457.68) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 1267.24,
    y: 402.23,
    width: 13.7,
    height: 104.6,
    transform: "translate(2604.75 211.11) rotate(150)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 419.88,
    width: 1128.74,
    height: 415.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 426.25,
    y: 6,
    width: 1116,
    height: 403.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 426.25,
    y: 6,
    width: 1116,
    height: 403.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M356.34,164.57c-3-8.99-13.79-25.78-34.17-28.78-20.38-3-206.85,2.4-218.24,7.79-11.39,5.4-74.35,176.26-74.35,206.04,0,38.17-2.8,68.16,2.8,89.94h145.21l5.17-4.8c15.78-14.64,36.51-22.78,58.03-22.78h116.29v-20.18c0-3.87,3.14-7,7-7,2.24,0,4.05-1.81,4.05-4.05v-86.69c0-27.98-8.79-120.51-11.79-129.5ZM240.22,281.44c0,9.45-6.37,17.7-15.5,20.11l-127.56,33.58c-11.55,3.04-22.71-5.98-22.24-17.91,1.57-39.32,10.85-78.66,31.34-128.14,2.82-6.81,8.28-10.73,17.45-10.73h107.92c3.94,0,8.59,4.65,8.59,10.39v92.69ZM336.55,280.58c0,6.13-4.97,11.09-11.09,11.09h-41.37c-6.13,0-11.09-4.97-11.09-11.09v-91.13c0-6.13,4.97-11.09,11.09-11.09h41.37c6.13,0,11.09,4.97,11.09,11.09v91.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M239.94,354.03h-22.7c-4.52,0-8.19-3.67-8.19-8.19h0c0-4.52,3.67-8.19,8.19-8.19h22.7c4.52,0,8.19,3.67,8.19,8.19h0c0,4.52-3.67,8.19-8.19,8.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 213.75,
    y: 342.27,
    width: 28.17,
    height: 7.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M214.65,349.41h-7.62c-1.97,0-3.57-1.6-3.57-3.57h0c0-1.97,1.6-3.57,3.57-3.57h7.62v7.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M241.03,342.27h7.62c1.97,0,3.57,1.6,3.57,3.57h0c0,1.97-1.6,3.57-3.57,3.57h-7.62v-7.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 215.17,
    y: 343.27,
    width: 25.34,
    height: 5.14,
    rx: 1.11,
    ry: 1.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M381.8,453.8c0-25.52-20.69-46.21-46.21-46.21h-104.53c-30.03,0-57.31,17.48-69.85,44.76l-27.85,60.56h7.11c8.07,0,15.4-4.7,18.77-12.03l18.77-40.81c9.53-20.72,30.25-34,53.05-34h104.54c15.31,0,27.73,12.41,27.73,27.73v45.06c0,7.76,6.29,14.06,14.06,14.06h4.43v-59.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M367.39,445.36v108.78c0,15.1,1.6,18.96,6.78,30.3,3.47,7.57,10.51,12.35,17.74,8.88l3.55-1.7c1.69-.81,1.82-3.33.19-4.28-6.07-3.52-23.11-6.5-24.13-33.68-1.62-43.08.07-113.48-4.13-108.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M357.3,167.87H117.75c-8.54,0-16.2,5.07-19.52,12.93-10.67,25.25-35.48,90.47-35.48,150.45v108.32h2.4v-108.32c0-59.55,24.68-124.4,35.29-149.52,2.94-6.96,9.73-11.46,17.31-11.46h135.21c2.15.72,3.72,2.73,3.72,5.12v217.13c0,9.58-7.79,17.37-17.37,17.37h-5.71v1.8h5.71c10.57,0,19.17-8.6,19.17-19.17v-217.13c0-2-.82-3.81-2.14-5.12h100.96c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M386.51,451.56c0-26.49-21.47-47.96-47.96-47.96h-108.5c-31.17,0-59.48,18.14-72.5,46.46l-28.91,62.86h7.37c8.38,0,15.98-4.88,19.48-12.49l19.48-42.36c9.89-21.51,31.39-35.29,55.07-35.29h108.5c15.89,0,28.78,12.88,28.78,28.78v46.76c0,8.06,6.53,14.59,14.59,14.59h4.6v-61.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 74.39,
    y: 421.33,
    width: 20.71,
    height: 12.88,
    rx: 1.64,
    ry: 1.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M77.85,422.26h13.79c1.29,0,2.33,1.04,2.33,2.33v6.34c0,1.29-1.04,2.33-2.33,2.33h-13.79c-1.29,0-2.33-1.04-2.33-2.33v-6.34c0-1.29,1.04-2.33,2.33-2.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 91.09,
    y: 423.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 91.28,
    y: 423.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 88.12,
    y: 423.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.31,
    y: 423.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 85.15,
    y: 423.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.34,
    y: 423.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 82.18,
    y: 423.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 82.37,
    y: 423.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 79.21,
    y: 423.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.4,
    y: 423.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 76.23,
    y: 423.31,
    width: 2.17,
    height: 8.91,
    rx: 0.51,
    ry: 0.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.43,
    y: 423.49,
    width: 1.44,
    height: 2.53,
    rx: 0.34,
    ry: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M28.95,392h0c-.25,18.74.1,34.62,3.43,47.56h8.89v-35.24c0-6.8-5.52-12.32-12.32-12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M42.47,404.32c0-7.45-6.06-13.52-13.52-13.52-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2c6.13,0,11.12,4.99,11.12,11.12v35.24h2.4v-35.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M39.77,352.65c0-21.13,28.84-110.02,51.01-167.03,1.36-3.5-1.23-7.26-4.99-7.26h-.22c-22.55,52.9-55.99,149.56-55.99,171.26,0,2.71-.02,5.37-.04,8.01h5.3c2.72,0,4.94-2.2,4.94-4.93v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M92.59,336.93c-4.24,0-8.36-1.43-11.78-4.18-4.74-3.81-7.33-9.49-7.08-15.57,1.61-40.29,11.3-79.94,31.43-128.55,3.15-7.61,9.39-11.47,18.56-11.47h107.92c4.53,0,9.79,5.06,9.79,11.59v92.69c0,9.98-6.74,18.73-16.39,21.27l-127.56,33.58c-1.62.43-3.26.64-4.88.64ZM123.71,179.56c-8.21,0-13.56,3.27-16.34,9.99-20.01,48.34-29.65,87.73-31.25,127.73-.21,5.32,2.04,10.28,6.19,13.61,4.13,3.31,9.43,4.44,14.55,3.09l127.56-33.58c8.6-2.26,14.61-10.06,14.61-18.95v-92.69c0-4.95-4.07-9.19-7.39-9.19h-107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M325.46,292.87h-41.37c-6.78,0-12.29-5.51-12.29-12.29v-91.13c0-6.78,5.51-12.29,12.29-12.29h41.37c6.78,0,12.29,5.51,12.29,12.29v91.13c0,6.78-5.51,12.29-12.29,12.29ZM284.09,179.56c-5.45,0-9.89,4.44-9.89,9.89v91.13c0,5.45,4.44,9.89,9.89,9.89h41.37c5.45,0,9.89-4.44,9.89-9.89v-91.13c0-5.45-4.44-9.89-9.89-9.89h-41.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M34.83,358.82h-5.3c-.66,0-1.2-.54-1.2-1.2s.54-1.2,1.2-1.2h5.3c2.06,0,3.74-1.67,3.74-3.73,0-22.09,30.26-113.96,51.09-167.51.5-1.29.34-2.68-.44-3.82-.79-1.15-2.04-1.81-3.43-1.81-.66,0-1.31-.54-1.31-1.2s.42-1.2,1.09-1.2c2.39,0,4.41,1.07,5.63,2.85,1.22,1.78,1.48,4.04.69,6.05-23.55,60.54-50.92,146.5-50.92,166.59,0,3.43-2.75,6.18-6.14,6.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 1369.23,
    y: 420.19,
    width: 53.37,
    height: 25.65,
    rx: 3.6,
    ry: 3.6,
    transform: "translate(2791.83 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1371.57,
    y: 422.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2766.8 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1372.49,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2747.75 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1373.17,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2748.19 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1376.3,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2755.37 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1376.98,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2755.81 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1380.11,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2762.99 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1380.79,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2763.43 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1383.92,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2770.61 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1384.6,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2771.05 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1387.73,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2778.23 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1388.41,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2778.66 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 1391.54,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2785.85 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1392.22,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2786.28 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1396.6,
    y: 422.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(2816.86 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1397.52,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2797.81 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1398.2,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2798.25 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1401.33,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2805.43 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1402.01,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2805.87 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1405.14,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2813.05 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1405.82,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2813.49 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1408.95,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2820.67 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1409.63,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2821.11 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1412.76,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2828.29 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1413.44,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2828.72 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1416.57,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(2835.91 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1417.25,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(2836.34 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M794.39,420.19h46.17c1.99,0,3.6,1.61,3.6,3.6v18.44c0,1.99-1.61,3.6-3.6,3.6h-46.17c-1.99,0-3.6-1.61-3.6-3.6v-18.44c0-1.99,1.61-3.6,3.6-3.6Z",
    transform: "translate(1634.95 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 793.14,
    y: 422.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1609.92 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 794.05,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1590.88 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 794.73,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1591.31 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 797.86,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1598.5 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 798.54,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1598.93 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 801.67,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1606.11 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 802.35,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1606.55 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 805.48,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1613.73 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 806.16,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1614.17 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 809.29,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1621.35 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 809.97,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1621.79 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 813.1,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1628.97 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 813.78,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1629.41 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 818.17,
    y: 422.91,
    width: 23.65,
    height: 20.22,
    rx: 3.58,
    ry: 3.58,
    transform: "translate(1659.99 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 819.08,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1640.94 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 819.76,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1641.37 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 822.89,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1648.56 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 823.57,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1648.99 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 826.7,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1656.18 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 827.38,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1656.61 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 830.51,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1663.79 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 831.19,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1664.23 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 834.32,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1671.41 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 835,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1671.85 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 838.13,
    y: 424.84,
    width: 2.78,
    height: 16.37,
    rx: 0.78,
    ry: 0.78,
    transform: "translate(1679.03 866.04) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 838.81,
    y: 425.16,
    width: 1.85,
    height: 4.65,
    rx: 0.52,
    ry: 0.52,
    transform: "translate(1679.47 854.97) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "430.25 8.79 1542.25 8.79 1542.25 6 426.25 6 426.25 409.79 430.25 409.79 430.25 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M16.73,311.64c-.4.12-.83.17-1.27.14-1.82-.12-3.08-1.54-2.83-3.19,2.09-13.66-6.85-24.06-6.94-24.16-1.09-1.25-.8-3.13.67-4.21,1.46-1.08,3.54-.94,4.64.31.44.49,10.68,12.3,8.21,28.48-.19,1.25-1.2,2.26-2.47,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M7.69,281.48c-.43-.49-1.03-.76-1.67-.9-1.12,1.1-1.32,2.71-.33,3.84.09.1,3.87,7.76,6.94,24.16.28,1.48.82,2.75,2.37,3.07.47-.46.8-1.05.9-1.7,2.47-16.18-7.77-27.99-8.2-28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M128.21,171.56h-4.65c-.96,0-1.78.58-2.17,1.4H23.95c-13.21,0-23.95,10.75-23.95,23.95v96.79c0,9.82,5.89,18.54,15,22.21l65.88,26.56c.03,1.3,1.08,2.35,2.39,2.35h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4h-4.65c-.44,0-.82.15-1.18.35l-66.2-26.69c-5.23-2.11-9.27-6.08-11.51-10.97l7.92-3.19c.63-.25.94-.97.68-1.61-.26-.63-.97-.94-1.61-.68l-7.89,3.18c-.69-2.13-1.09-4.39-1.09-6.72v-62.87h12.78c.66,0,1.2-.54,1.2-1.2s-.54-1.2-1.2-1.2H2.4v-31.52c0-11.89,9.67-21.55,21.55-21.55h97.71c.44.59,1.1,1,1.9,1h4.65c1.32,0,2.4-1.07,2.4-2.4s-1.07-2.4-2.4-2.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-134",
    cx: 15.79,
    cy: 228.72,
    rx: 6.1,
    ry: 41.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M16.55,186.18h.98v85.07h-.98c-4.61,0-8.34-3.74-8.34-8.34v-68.38c0-4.61,3.74-8.34,8.34-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M8.21,194.46h.1c1.8,0,3.25,1.46,3.25,3.25v62.02c0,1.8-1.46,3.25-3.25,3.25h-.1v-68.53h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2AxSingleBedford);
export default __webpack_public_path__ + "static/media/2-Ax_Single_Bedford.a4c333489b4d1ac34085e8c5e8a01912.svg";
export { ForwardRef as ReactComponent };